export const zh = {
    "k_6db841d5": "默认红",
    "k_670d606a": "腾讯蓝",
    "k_88054631": "天空蓝",
    "k_4e9d4bb6": "页面/链接跳转失败: {arg_0}",
    "k_fa57d441": "无效页面路径",
    "k_ce12e0f9": "路径解析失败: 动态路径参数不能为空",
    "k_ecdd0af9": "动态路径解析失败",
    "k_67bd925c": "文件名不能包含中文字符",
    "k_8ac70fc4": "无响应",
    "k_c4097d2": "响应内容有误",
    "k_840f84df": "loadAmdModule 函数调用缺少必要的 amdKey 参数",
    "k_f73092c": "应用信息",
    "k_effb261f": "发布管理",
    "k_e5f6f1": "授权",
    "k_62caf1cb": "日志 | 数据",
    "k_d01cf670": "权限管理",
    "k_78539ebc": "设置",
    "k_25bcc5f5": "页面列表",
    "k_3a98802c": "添加页面",
    "k_3839254f": "标签管理",
    "k_e3c46e83": "通用配置",
    "k_f4c7d984": "应用ID",
    "k_8828fcda": "应用中文名",
    "k_6d2a8848": "描述",
    "k_8fc3cc81": "类型",
    "k_c8827c39": "运营产品",
    "k_89b814e7": "管理者",
    "k_3fb5305c": "开发者",
    "k_7e42d01e": "页面主题色",
    "k_3b2d9eab": "设计风格",
    "k_b58f0075": "默认布局风格",
    "k_1f227f74": "网页图标",
    "k_adc0f26c": "网页图标(favicon)配置浏览器在标签页中显示的图标",
    "k_e229c4dc": "首页",
    "k_4a6b04b5": "应用首页和根路径(/)重定向的页面; 支持配置页面路径为 / 的页面作为应用默认首页",
    "k_a98630c": "403 重定向",
    "k_a00fcd6d": "请求接口返回 403 时重定向的页面",
    "k_c955c0dd": "隐藏页面进度条",
    "k_6d26d2b6": "是否隐藏页面顶部的加载进度条",
    "k_e74d3713": "消息提醒样式",
    "k_6d8df820": "定义页面运行时的错误消息如何展示，默认是“通知浮层”",
    "k_5ec25129": "水印功能",
    "k_6c148ff2": "这里开启的是全局水印功能(所有页面生效), 如果希望单个页面生效请到页面中单独设置",
    "k_b3ab77c6": "小满反馈",
    "k_1975746f": "这里开启的是正式环境的小满功能。",
    "k_7d88b15f": "小满是一个满意度反馈的平台，其中小满ID是您的管理平台的唯一ID。",
    "k_262efe35": "需要了解小满相关内容及生成小满ID可前往小满官网。",
    "k_b58db0f1": "前端监控",
    "k_22d48703": "这里开启的是平台内置的运行时前端监控。",
    "k_d8fc33e3": "开启有助于平台更快速定位具体问题",
    "k_ddf5b5ce": "代理上报",
    "k_581b029f": "默认为关闭, 运行时使用前端直接上报",
    "k_a1a4e2f2": "开启时, 运行时使用后台代理上报",
    "k_1aef2bf6": "站内公告",
    "k_4537ec7d": "这里开启的是编辑时站内公告配置，以及运行时站内公告展示",
    "k_a1ce8a13": "应用导航",
    "k_334838e7": "应用导航为运行时所有页面的导航配置, 优先级低于页面的单独配置",
    "k_7bd7538b": "应用菜单",
    "k_f95d97ec": "应用菜单为运行时所有页面的菜单配置, 优先级低于页面的单独配置",
    "k_497394ec": "应用页头",
    "k_5971652d": "应用页头为运行时所有页面的页头配置, 优先级低于页面的单独配置",
    "k_bbf1b556": "应用页脚",
    "k_417624d8": "应用页脚为运行时所有页面的页脚配置, 优先级低于页面的单独配置",
    "k_5ffa78f0": "可见范围",
    "k_60b8cd55": "扩展配置",
    "k_f4b30c19": "自定义布局组件配置",
    "k_6dd2204": "全局路由守卫",
    "k_9af4f39a": "企业微信应用配置",
    "k_6830ea57": "应用 LessCode",
    "k_70adca95": "全局脚本配置",
    "k_c71f0afd": "全局图标配置",
    "k_f1a19541": "顶部导航",
    "k_3988cc00": "用户信息",
    "k_fa393bc": "应用名称",
    "k_f820b5d3": "应用Logo",
    "k_868fb9ab": "环境切换",
    "k_3a69a78e": "帮助文档",
    "k_1da199be": "我要反馈",
    "k_b5030ba1": "应用快捷切换面板",
    "k_5be772f": "固定头部导航",
    "k_10809af6": "显示页面层级关系",
    "k_67139b0a": "在导航下面使用面包屑来展示页面的层级关系，示例：<br/>",
    "k_66db464c": "一级目录 / 二级目录 / 页面xxx",
    "k_bb5cc522": "显示最近访问路由",
    "k_29589bc5": "在导航下面展示最近访问的页面，方便业务快速跳转",
    "k_195837bc": "显示水印区分环境",
    "k_eec2d063": "开发环境和测试环境导航栏显示水印防止误操作",
    "k_16c0c46b": "公共查询参数",
    "k_475fb85c": "公共查询参数的配置以 key=value 的形式拼接在链接的查询参数中, 并且在顶部导航栏中显示切换参数的组件",
    "k_caf66673": "启用业务隔离",
    "k_7bf9b398": "菜单组",
    "k_ad9f2f34": "右侧快捷入口",
    "k_933a2fcb": "导航栏组件",
    "k_3eabc597": "默认头像下拉菜单",
    "k_ade06fae": "自定义头像下拉菜单",
    "k_2df809bb": "权限配置",
    "k_c7e1579": "左侧菜单",
    "k_bd1e62a1": "菜单宽度",
    "k_c063b925": "菜单选项配置",
    "k_3dd5ca22": "显示应用标题",
    "k_35790c25": "显示菜单标题",
    "k_85ae821": "默认展开子级菜单",
    "k_cd400996": "手风琴模式",
    "k_30d6e973": "开启后左侧菜单只会展开当前选中的菜单项，其他菜单项将不会展开",
    "k_f4ca9fba": "显示搜索框",
    "k_eb778ee1": "菜单配置",
    "k_93c10ead": "审批流",
    "k_e4aba93f": "工作流",
    "k_1d522a5f": "高级流程",
    "k_ba4882ab": "执行记录",
    "k_e70cbccf": "全局配置",
    "k_462caeed": "数据源",
    "k_d321f1c": "发布记录",
    "k_2b12108c": "环境管理",
    "k_7e3424ab": "组件管理",
    "k_257d514f": "离线任务",
    "k_fa6c49f3": "应用相关授权",
    "k_d2b28cc0": "授权数据库",
    "k_499bf85a": "组件商店授权",
    "k_6829d7d0": "应用密钥",
    "k_761886c2": "应用COS",
    "k_973832d7": "接入第三方鉴权",
    "k_cd60b798": "设置第三方鉴权接口",
    "k_a7b6ece3": "后台鉴权数据源 ",
    "k_e3b361f4": "先设置第三方鉴权接口类型的数据源",
    "k_9c629ef": "第三方权限系统链接",
    "k_bc7a0f47": "日志查询",
    "k_16a0397a": "角色管理",
    "k_54d7bddb": "用户管理",
    "k_dc0e1e5d": "自定义权限",
    "k_97f9a523": "接口管理",
    "k_1f38dc46": "高级配置",
    "k_ad86af63": "公告管理",
    "k_1bb54a86": "分支管理",
    "k_71363dc9": "开启多分支",
    "k_7e903cb4": "开启后默认分支为master分支，用户可以创建或者切换分支，分支之间的操作互相独立。",
    "k_666b5a1a": "分支保护",
    "k_6de8fef8": "开启后用户将不允许直接在master进行修改，只能通过分支合并更新master",
    "k_4f801b54": "分支关联环境",
    "k_51558cf0": "开启后，分支创建时，会同时创建分支关联的环境并发布；当分支被删除时，关联环境也同时被删除",
    "k_9f615023": "发布设置",
    "k_30fd9431": "删除应用",
    "k_b3183783": "开启预发布环境",
    "k_f6b7caaa": "发布正式环境之前，默认先发布到预发布环境，验证通过后才继续发布到正式环境,流程如下：",
    "k_62dbaf6c": "开启发版审批",
    "k_282b7d04": "版本需要通过审批获得发布到正式环境的资格后才能发布到正式环境，默认审批人为直接上级",
    "k_d61c975": "允许直接从开发环境发布版本到正式环境",
    "k_ff732bad": "开启发布或回滚推送流程",
    "k_2e419d63": "编辑器设置",
    "k_51b2997": "启用 ESLint 检查",
    "k_ad9b7477": "配置后可以在 LessCode 编辑器内获得 ESLint 检查",
    "k_21a8cf5f": "ESLint 配置",
    "k_3f99db0b": "非法path,key={arg_0}",
    "k_fa6ef644": "Monaco Editor 加载失败[{arg_0}]",
    "k_c5058dce": "使用当前版本",
    "k_dc2406bd": "使用远程版本",
    "k_e0ef16ad": "保留两个版本",
    "k_653018a6": "JSON校验不通过",
    "k_73a2bbd": "请手动解决以下冲突：",
    "k_fec0159b": "个冲突待处理",
    "k_6f43491a": "上一个",
    "k_4c2d66eb": "下一个",
    "k_6124063b": "标记冲突已解决",
    "k_bbdbcc3a": "不合并,直接保存本地",
    "k_f2f7b4d0": "已合并",
    "k_7e7ce184": "待解决",
    "k_96e5aa9a": "取消合并",
    "k_2ebe236b": "提交合并",
    "k_fa9620cb": "解决冲突",
    "k_a724d646": "正在编译 {arg_0}",
    "k_d4789591": "编译 {arg_0} 失败: {arg_1}",
    "k_59a1f6f8": "编译 {arg_0} 失败:",
    "k_89af5848": "与 {arg_0} 于 {arg_1} 的修改合并存在冲突, 请手动解决冲突后提交合并",
    "k_32eb4eb8": "应用配置",
    "k_8d7ed5eb": "导航和菜单",
    "k_3cf11e77": "全局 LessCode",
    "k_b446678d": "Head 脚本",
    "k_9ada019f": "Body 脚本",
    "k_c61b4dc4": "项目模块({arg_0})",
    "k_67fa32f": "页面信息",
    "k_ff930951": "{arg_0} 布局",
    "k_1e7b8328": "缺少三路合并的必要参数",
    "k_1ba1a0a8": "<<<<<<< {arg_0}",
    "k_959f0002": "当前变更",
    "k_a14e0497": ">>>>>>> {arg_0}",
    "k_2e76ac78": "最新变更",
    "k_705a90ff": "{arg_0}服务: {arg_1}",
    "k_953d8775": "保存成功",
    "k_abda9ac5": "有部分字段保存失败",
    "k_9ea11a90": "保存失败",
    "k_8af2804d": "合并失败，保存取消",
    "k_96294861": "loading函数已经存在",
    "k_cfad831b": "[FormObject]不允许获取未加载的 formProp, path={arg_0}",
    "k_adcd509a": "[FormObject]不允许重复key加载, key={arg_0}",
    "k_2d0699f3": "不允许重复加载, key={arg_0}, bizId={arg_1}, path={arg_2}",
    "k_9b9ea9f1": "基础数据",
    "k_82edf9a3": "未找到字段prop配置，key={arg_0}",
    "k_3578a595": "修改合并存在冲突, 请手动解决冲突后提交合并",
    "k_b6d126e4": "MaterialContainer: config 不能为空",
    "k_4170fc6": "MaterialContainer: id {arg_0} 已经被占用，请更换其他id",
    "k_f455a003": "[routeFactory] 无法找到对应的materialId：{arg_0}",
    "k_3fed3f2a": "公告",
    "k_bf1560fe": "待办",
    "k_aa0a6c6b": "跳转至编辑页",
    "k_67996ed": "用小程序访问",
    "k_ef5d61e6": "默认",
    "k_338ab8ee": "菜单",
    "k_a42df797": "下拉菜单",
    "k_be33ba71": "CLI工具未启动调试命令，请检测后重试",
    "k_3280a516": "本地启动的是https服务，但是客户端请求的是http的接口。",
    "k_4050befb": "切换到https",
    "k_4aafc102": "本地启动的是http服务，但是客户端请求的是https的接口。",
    "k_22614c2f": "切换到http",
    "k_977bee88": "本地开发者工具启动https调试模式",
    "k_69809c15": "开发工具如何开启https本地服务",
    "k_816f4da": "https页面禁止加载http资源，因此加载本地开发资源失败。",
    "k_671d3581": "页面使用http重新加载",
    "k_91f3e981": "模块",
    "k_a5064e7f": "确定",
    "k_83ed1744": "取消",
    "k_f426d5ff": "很遗憾，加载本地开发{arg_0}失败",
    "k_e5c96995": "请求本地开发接口失败，通常为浏览器设置限制导致，可以按照以下指示逐一排查：",
    "k_a2cdd30b": "场景",
    "k_ae5a5c54": "- 控制台报错：",
    "k_8a3cf94f": "解决方法",
    "k_71f8a256": "请求本地开发接口失败，请使用Chrome浏览器进行开发",
    "k_28623d39": "组件",
    "k_25f31498": "初始化组件的hmr",
    "k_566711a": "加载失败，请保存页面再刷新",
    "k_4c8ca400": "组件加载中...",
    "k_1728204c": "初始化组件商店请求:{arg_0}",
    "k_70468b0a": "组件{arg_0}因为url参数被阻止实例化",
    "k_74c72245": "[simple-hook][{arg_0}]执行失败：",
    "k_c6ccb06f": "[npm-loader] 初始化失败: {arg_0}",
    "k_a6f1b0f4": "有重复打开的编辑器",
    "k_27c2888e": "您打开了另一个同页面的编辑器",
    "k_6dcc9c5c": "当前编辑器的预览功能已被暂停使用",
    "k_c14c8fff": "激活当前编辑器",
    "k_5db66351": "关闭提示",
    "k_496f68fc": "数据源更新",
    "k_5224f09c": "强制重新加载",
    "k_51770493": "项目信息修改",
    "k_40cc9bd3": "逻辑或数据源变化",
    "k_d5ca7a1e": "组件框架切换钩子编译失败",
    "k_9f139ac3": "请解决冲突",
    "k_13c95a70": "已自动合并本地落后的远程修改",
    "k_e04a289d": "当前版本和最新版本有冲突，请解决冲突后进行保存",
    "k_c760bc65": "当前版本",
    "k_946da0be": "最新版本",
    "k_4c057df1": "检测应用ID失败",
    "k_3d1fff4c": "拉取应用数据失败：{arg_0}",
    "k_64fcd9c": "切换项目获取数据失败：{arg_0}",
    "k_3df9b7d6": "合并应用修改冲突失败, 取消保存",
    "k_8b3fa3c9": "保存成功 (已合并本地落后的远程修改)",
    "k_7675c03d": "获取应用设置失败:{arg_0}",
    "k_c6e2835e": "获取权限设置失败:{arg_0}",
    "k_8c7535ce": "加载失败",
    "k_26490786": "检测到页面资源加载失败，请刷新页面重试",
    "k_3ac2cf99": "刷新页面",
    "k_2e43c98f": "获取cookie失败：{arg_0}",
    "k_25a56892": "发起时自动填表",
    "k_35b9cacb": "页面片",
    "k_b35069c8": "流程实例详情",
    "k_956ecf04": "未命名折叠面板",
    "k_e6b58562": "流程单ID: `{{ job.id }}` / 网址",
    "k_c4fbc89d": "复制",
    "k_ba3128ef": "job.id // 新建流程单时不展示",
    "k_c207e9e8": "当前审批人为：{{ job.currentApprovers || '...' }}",
    "k_73e8a755": "复制信息 + 一键拉群",
    "k_3da3caaa": "复制信息",
    "k_11589b60": "您好，请留意审批单据《{{ job.title }}》\n\n{{ job.url }}",
    "k_1173bad5": "流程运行中",
    "k_d649582a": "流程: {{ job.title }}",
    "k_f7508b44": "刷新",
    "k_a8e2ba8e": "页面停留时长",
    "k_f669486d": "元素点击",
    "k_97462910": "元素曝光",
    "k_d7cfe3a8": "元素行为",
    "k_d5792003": "除 “元素点击” 事件外的其他组件行为事件（比如切换选项卡，行为ID需填 “${组件ID}:${事件ID}”）",
    "k_7b830b83": "总访问次数",
    "k_f1226738": "总访问人数",
    "k_6161add9": "人均次数",
    "k_714deb0d": "停留时长[平均值:秒]",
    "k_b6581704": "停留时长[最大值:秒]",
    "k_8d48a539": "扩展字段{arg_0}",
    "k_7174abb5": "组件路径",
    "k_59b4978": "页面",
    "k_a3aeb4a1": "导航",
    "k_dee04081": "页头",
    "k_aa3fe1fb": "页脚",
    "k_ab346fdc": "弹窗",
    "k_c0c196cd": "导航-菜单-内容",
    "k_902c005": "导航-内容",
    "k_c27629db": "菜单-内容",
    "k_389afe34": "内容",
    "k_95061ec5": "跟随应用",
    "k_a6cf7a31": "固定",
    "k_ea62011c": "不固定",
    "k_175cf024": "开启",
    "k_10c72f14": "关闭",
    "k_b4a8e78b": "修改",
    "k_4548279c": "页面JS资源加载失败",
    "k_5ea52ff6": "页面操作请求参数错误",
    "k_a327c337": "获取页面列表失败",
    "k_f8a42775": "合并页面修改冲突失败, 取消保存",
    "k_f61e0369": "拉取页面数据失败：{arg_0}",
    "k_803f7289": "开发环境",
    "k_5a4c29f0": "测试环境",
    "k_49cd5983": "正式环境",
    "k_c858e1d2": "预发布环境",
    "k_6983648b": "获取应用环境列表失败",
    "k_65ff08f8": "该环境已被系统使用，请设置另外一个环境id",
    "k_1be7444b": "{arg_0} 环境暂未发布版本，当前无可比较的版本",
    "k_32152ba5": "获取当前页面版本差异失败:{arg_0}",
    "k_62652f5c": "提交版本失败:{arg_0}",
    "k_6121940c": "获取版本列表失败:{arg_0}",
    "k_75bb38e3": "发布版本失败:{arg_0}",
    "k_25723de0": "获取当前应用版本列表失败:{arg_0}",
    "k_c6869e21": "同步环境数据失败:{arg_0}",
    "k_5a50c201": "获取版本发布内容失败",
    "k_a1dc90c0": "版本终止失败:{arg_0}",
    "k_773e03d4": "操作失败{arg_0}",
    "k_e06499d": "导入成功",
    "k_75fe854": "导入失败: {arg_0}",
    "k_4ebe7f51": "执行前置钩子失败: {arg_0}",
    "k_ff20d88b": "获取导入钩子失败: {arg_0}",
    "k_5c5e3d06": "页面加载失败，{arg_0}",
    "k_20db7ab8": "[getPageDetail] JSON.parse 失败",
    "k_bcd15456": "同意",
    "k_46f0b9ac": "驳回",
    "k_54e0c700": "缺少nodeId",
    "k_62c780f5": "获取流程",
    "k_4876b2f7": "流程id",
    "k_3e9b02f0": "审批",
    "k_171f4a68": "审批节点id",
    "k_279f7fb6": "同意/拒绝",
    "k_b18fa4f2": "审批意见",
    "k_7e41b35c": "表单数据",
    "k_cd38bccc": "启动流程",
    "k_6faa5926": "流程数据",
    "k_9047817e": "获取流程配置",
    "k_16a7ee42": "获取审批节点信息",
    "k_cb6d514f": "获取日志节点信息",
    "k_a7ef3e87": "获取全量流程",
    "k_10eb0273": "标题",
    "k_69738fe5": "流程标题，空字符串为不过滤",
    "k_6cf18673": "发起人",
    "k_28f4b25a": "发起人，空字符串为不过滤",
    "k_74c6885e": "根据类型获取流程",
    "k_b809779": "流程类型",
    "k_3aff6028": "我发起的",
    "k_a5c4ef48": "我参与的",
    "k_d2e41051": "与我相关",
    "k_619e3485": "审批代办",
    "k_dc7f55f9": "组织架构",
    "k_5d911031": "搜索用户",
    "k_688d063": "过滤",
    "k_b4b19a60": "获取用户",
    "k_50e0cc3f": "用户id",
    "k_d4ee9699": "id: 页面ID; path: 页面路径; query: 查询参数; params: 路由参数",
    "k_b4051f8": "页面ID",
    "k_1e6ffc69": "页面名称",
    "k_d7996547": "页面标题",
    "k_8e33b139": "页面路径",
    "k_4c403e": "全局常量",
    "k_6b2526c": "部门ID",
    "k_19d85b52": "部门IDs(分号;分割)",
    "k_804e17d3": "中心IDs(分号;分割)",
    "k_a38949fb": "职位",
    "k_c095a944": "登录渠道前端数据",
    "k_64fd4991": "可以在登录渠道-登录钩子中，按照业务需要，通过 ctx.frontendData.xxx = ... 注入数据",
    "k_afde2c92": "切换账号",
    "k_3fcb6f75": "显示账号切换浮窗。\n\n可以 await 并得到布尔值，表示用户是否执行了切换操作。",
    "k_f8cbcf73": "切换后是否刷新页面？默认 true",
    "k_1ce4b236": "模式",
    "k_fec0a056": "当前环境类型",
    "k_5d87d036": "当前用户",
    "k_bef7d5f": "用户ID",
    "k_5e7c1fb9": "英文名",
    "k_7500f155": "中文名",
    "k_85b228c6": "部门名",
    "k_5d9522b": "组织名(斜杠/分割)",
    "k_b42c7510": "组织IDs(分号;分割)",
    "k_8310207": "头像图地址",
    "k_cf39d58f": "编辑侧身份",
    "k_8e1ed2c9": "是否管理员",
    "k_b71fa3b6": "是否登录",
    "k_749a6a57": "所属角色列表",
    "k_b94ae843": "预览模式下无",
    "k_1de7d36d": "角色名",
    "k_aa5c52ce": "权限项",
    "k_9bf51032": "权限项ID",
    "k_1380578c": "权限项关联的页面ID",
    "k_67298115": "权限项关联的角色名",
    "k_80bfff5": "中心ID",
    "k_abbf5d6": "小组ID",
    "k_c8eec1a9": "退出登录",
    "k_afd01e56": "注意：会离开当前页面",
    "k_37711124": "提示",
    "k_2e478339": "成功提示",
    "k_b0104f9d": "提示内容",
    "k_8106ac9f": "警告提示",
    "k_1b5acfe9": "错误提示",
    "k_5d0d5ccd": "加载提示",
    "k_901ce8d8": "全局 LessCode 实例",
    "k_5092fb0a": "相关流程单",
    "k_3ad57267": "流程单ID",
    "k_425d0c81": "审批人",
    "k_92730769": "流程状态节点ID",
    "k_e7115459": "流程状态节点名",
    "k_90ac2ee": "流程状态",
    "k_6ac42065": "环境",
    "k_9dafa028": "实体ID",
    "k_de407ccd": "流程ID",
    "k_44d0bc15": "获取流程单列表",
    "k_e61b864": "流程单类型",
    "k_24745bd4": "筛选条件",
    "k_e74d6eb8": "获取流程单详情",
    "k_7e4ddb24": "获取流程审批记录",
    "k_6bbb26c1": "发起流程",
    "k_84f262e2": "流程配置ID",
    "k_ca9de38f": "审批数据",
    "k_294155ce": "审批流程",
    "k_182f935e": "重新发起流程",
    "k_9c38f466": "撤销流程",
    "k_cd928a8e": "流程单是否进行中",
    "k_b988962f": "流程单",
    "k_f7f0ad7": "当前用户能否审批",
    "k_b3232aac": "重新指派审批人",
    "k_9df2b850": "审批人, 多个审批人使用英文逗号(,)分割",
    "k_56b8b199": "应用图标",
    "k_67c40419": "主页面信息",
    "k_77b66f0b": "获取当前的菜单组",
    "k_15048c42": "设置当前的菜单组",
    "k_8802dca4": "菜单组名",
    "k_9f906f81": "设置当前选中的菜单项",
    "k_bb362f85": "多级的菜单项名",
    "k_79de9171": "设置当前菜单收起/展开态",
    "k_ff0e1c2f": "是否收起菜单",
    "k_9780da86": "获取当前菜单数据",
    "k_7807e7c8": "获取平台菜单数据",
    "k_ff8096c2": "设置菜单数据",
    "k_beead710": "菜单数据",
    "k_33ee7983": "获取当前菜单名",
    "k_b9d153c6": "当前域名",
    "k_5d765ff6": "当前路径",
    "k_48857b7c": "路由查询参数",
    "k_2bb38f4a": "路由动态参数",
    "k_39551160": "确认框",
    "k_20c3663b": "确认框配置项",
    "k_293e7ce5": "确认框标题",
    "k_accc868": "确认框内容",
    "k_40f69562": "确认按钮文本",
    "k_d746b537": "取消按钮文本",
    "k_8164a120": "确认回调函数",
    "k_95eee7a9": "取消回调函数",
    "k_489b7125": "打开全局弹窗",
    "k_1c4ee350": "打开页面类型为弹窗的全局弹窗",
    "k_f9df9c": "需要打开的全局弹窗id(弹窗页面id)",
    "k_c9b86b9f": "打开全局弹窗的传参",
    "k_7dc3e87e": "全局弹窗的配置项，keepAlive是否保留实例，suffix用来区分实例的后缀名",
    "k_2fa4e109": "关闭全局弹窗",
    "k_b81bddf8": "关闭页面类型为弹窗的全局弹窗",
    "k_8d94ad51": "需要关闭的\"全局弹窗id_后缀suffix\"(\"弹窗页面id__后缀suffix\")",
    "k_a3efaa1f": "关闭全局弹窗的返回值",
    "k_866e07f7": "关闭全局弹窗的配置项，destroy是否强制销毁实例",
    "k_ecfdad6e": "调用云函数",
    "k_ed3d16ac": "云函数id",
    "k_18bc59c2": "透传的 axios 配置参数(可选)",
    "k_179b3b81": "根据 key 获取公共参数的值",
    "k_f7f034fd": "公共参数 key",
    "k_634e9504": "根据 key 获取公共参数的选项",
    "k_f517814e": "根据 key 重新请求公共参数的选项",
    "k_af9a1d3b": "请求完成后顶部导航左上角的公共参数组件选项也会更新",
    "k_385deb37": "判断用户权限方法",
    "k_30435cfb": "判断当前用户有没有自定义权限，如：w.hasPermission(\"custom-permission-id\")",
    "k_df46af87": "权限ID(例如 `\"custom-permission-id\"`)",
    "k_ad5d6da": "跳转页面",
    "k_d59cac02": "跳转到应用内的指定页面, 保留当前页面",
    "k_fdfafdf3": "跳转到应用内的指定页面, 关闭当前页面",
    "k_f6561836": "新窗口打开页面",
    "k_7ffd6bb3": "新窗口打开指定页面",
    "k_d70a0368": "获取解析的页面路径",
    "k_cc480ccb": "将页面滚动到目标位置",
    "k_7b0316b3": "滚动参数, 具体请查看前端 API 文档",
    "k_37b003e2": "上报",
    "k_676ffdd": "上报数据",
    "k_ebeb0203": "事件名称",
    "k_824ce41f": "元素ID",
    "k_496f9183": "行为事件",
    "k_f94021f4": "弹出消息窗口",
    "k_6c21d053": "弹出确认框",
    "k_180ccf54": "垂直居中展示",
    "k_c72881c6": "图标",
    "k_f643e952": "确认的回调函数",
    "k_27835c43": "取消的回调函数",
    "k_c3e01b2f": "弹出文字输入框",
    "k_87b97ef6": "默认输入文本",
    "k_34f51639": "文本类型",
    "k_2b922dc5": "允许空字符串",
    "k_4be19654": "弹出提示",
    "k_fb99065f": "持续时间",
    "k_6d00667a": "弹出通知框",
    "k_9cd43e7e": "通知类型",
    "k_e5235e35": "位置",
    "k_9adebda7": "校验表单",
    "k_4c9a311f": "表单对象",
    "k_92596fa8": "校验错误信息",
    "k_a11a741b": "调用LessCode方法",
    "k_e2212c0c": "LessCode方法名",
    "k_bd62d0a0": "复制文本",
    "k_81daa3b0": "文本",
    "k_5fcf4d2d": "是否弹出复制成功提醒",
    "k_85be1567": "数据源操作",
    "k_6e87ec70": "数据源ID",
    "k_baaf2048": "数据源方法名",
    "k_59c09a5a": "数据源方法入参",
    "k_557e6824": "数据源重新初始化",
    "k_3c39e538": "上传至COS",
    "k_cd081a4c": "COS桶ID（默认一般为 \"default\"）",
    "k_de0484e8": "文件内容（字符串或Blob）",
    "k_e839028a": "上传到路径",
    "k_b3272cb3": "多环境配置（可选）",
    "k_a691eb9": "上传头部（可选）",
    "k_23373bc5": "上传后生成的文件URL",
    "k_6809e9d5": "Excel导出",
    "k_50b570bc": "导出数据",
    "k_350ec636": "导出字段",
    "k_557187b6": "字段key",
    "k_e30c871a": "字段名",
    "k_760abed2": "文件名",
    "k_42114a9f": "Sheet名",
    "k_b5de97d2": "导出格式",
    "k_1f3cd2f4": "Excel导入",
    "k_a1b1698d": "参数",
    "k_5cfef3e1": "是否为原始数据",
    "k_cc449b3d": "是否以 Date 输出日期类型",
    "k_8f182987": "字符集",
    "k_5c776d11": "提取文件数据",
    "k_1a587cd5": "是否多选",
    "k_a630d32e": "是否支持文件夹",
    "k_a2c301ef": "跳转链接",
    "k_812867e": "链接地址",
    "k_26da58db": "是否新窗口打开",
    "k_2490874": "返回上一页",
    "k_ff216fbf": "刷新页面片",
    "k_9b3199e4": "滚动页面",
    "k_5658bf6e": "滚动位置",
    "k_28098687": "垂直滚动距离(px)",
    "k_dbe68ac8": "组件ID",
    "k_5b429f8b": "组件偏移类型",
    "k_f8b051f9": "组件偏移距离(px)",
    "k_49f0e26": "滚动行为",
    "k_29510c35": "保存草稿",
    "k_8ee067a1": "草稿命名空间",
    "k_714bd626": "是否显示确认弹窗",
    "k_202752ab": "恢复草稿",
    "k_5fce6fb0": "取消后是否保留草稿",
    "k_895cadaf": "删除草稿",
    "k_c5052b21": "邮件通知",
    "k_3a3856d5": "收件人邮箱",
    "k_7ba688d4": "抄送人邮箱",
    "k_e996f2ec": "密送人邮箱",
    "k_80755700": "邮件标题",
    "k_d8bbcc26": "邮件内容",
    "k_6a73fffe": "企微机器人通知",
    "k_78442bab": "机器人ID",
    "k_d4c387bd": "通知内容",
    "k_871a2b73": "是否弹出成功提醒",
    "k_76deb9d2": "企业微信通知",
    "k_26dfe8b8": "接收人，多个接收人使用英文逗号(,)分割",
    "k_9dcb759a": "通知标题",
    "k_c578bff5": "通知描述",
    "k_91d67a50": "通知链接",
    "k_99a738b7": "通知按钮文本",
    "k_6ebe5600": "唤起企业微信",
    "k_ecf43a43": "发送GPT消息",
    "k_550f765b": "系统预设Prompt",
    "k_f81c9678": "消息内容",
    "k_2da7ea70": "返回消息形式",
    "k_1013fb89": "JSON字符串",
    "k_85bf7666": "调用方法",
    "k_976bc490": "语言模型",
    "k_bb65fe69": "当前主页面的页面片实例",
    "k_dd04ffae": "查询参数工具",
    "k_432bf6f0": "转换为过滤数组",
    "k_e67e4b23": "过滤条件",
    "k_473a7ed6": "选项",
    "k_82cefc2e": "转换为过滤表达式",
    "k_af2f5511": "转换为嵌套过滤表达式",
    "k_d72c9a1": "全局自定义事件",
    "k_5c8b673a": "平台预设事件",
    "k_2ae35487": "全局前置守卫",
    "k_5769cb98": "全局后置守卫",
    "k_b35037a0": "页面销毁前",
    "k_93af025f": "页面销毁",
    "k_6f4c4660": "页面数据源就绪",
    "k_df4be9a1": "页面标题修改",
    "k_282d5f6d": "监听事件",
    "k_d709f01c": "事件名",
    "k_eadb18cc": "事件处理函数",
    "k_71716b0": "监听事件(仅触发一次)",
    "k_cc60abc1": "取消监听事件",
    "k_949dce81": "触发事件",
    "k_35a1ec73": "事件参数",
    "k_d4725bd1": "权限",
    "k_26abe818": "获取角色列表",
    "k_e879fbcb": "获取角色-用户列表",
    "k_cb0e8b54": "选填，根据业务ID过滤",
    "k_651210a5": "选填，根据角色ID过滤",
    "k_cba0e07e": "选填，用户id或类型type限定",
    "k_a74c2567": "获取角色-权限列表",
    "k_5af39aee": "角色ID",
    "k_bb84828c": "获取角色相关权限及用户",
    "k_fc86b69d": "获取自定义权限列表",
    "k_9e4afe20": "获取内置权限列表",
    "k_1bb1b1f9": "获取接口-权限列表",
    "k_d4f0b53b": "新建角色",
    "k_1b18e8e9": "角色信息",
    "k_f9b55d97": "角色英文名",
    "k_ae615ff9": "角色中文名",
    "k_8bb73dbc": "类型，一般为空字符串即可，若是业务类型角色，则是 biz",
    "k_7488231a": "更新角色",
    "k_8cf55902": "只有 cname 可以更新",
    "k_97bda7ed": "删除角色",
    "k_a55875dd": "新建权限",
    "k_2c97ec6a": "权限信息",
    "k_f2e2e311": "权限英文名",
    "k_b54458d1": "权限中文名",
    "k_318dce62": "类型为 page 时，可关联页面id, 逗号分隔",
    "k_8d54bf52": "更新权限",
    "k_69dbd344": "只有 cname 和 relatedPages 可以更新",
    "k_29da5cbf": "删除权限",
    "k_4e7e068b": "新增角色成员",
    "k_c4149bf5": "角色成员信息",
    "k_14314ec0": "用户英文名",
    "k_dee6b505": "名称",
    "k_2c818d6": "用户类型",
    "k_f65edbbd": "业务id, 业务隔离，若角色是业务类型，必填",
    "k_76762b9c": "过期时间截，ms",
    "k_9e9a70e2": "删除角色成员",
    "k_8617382": "角色成员记录id",
    "k_177f55ae": "新增角色权限",
    "k_a72d6c1d": "角色权限信息",
    "k_db13d6d4": "页面id，页面相关权限必填",
    "k_3c1557fd": "删除角色权限",
    "k_5b6015f2": "角色权限记录id",
    "k_d8c8d661": "批量删除角色权限",
    "k_b294b93f": "角色权限记录id列表",
    "k_d1f26184": "新增接口权限绑定",
    "k_3345f8e2": "接口权限绑定信息",
    "k_da3197fa": "接口名",
    "k_25a152be": "删除接口权限绑定",
    "k_32b0e6c5": "接口权限绑定记录id",
    "k_3964eb77": "获取公告列表",
    "k_121a2081": "刷新公告",
    "k_850ced59": "水印",
    "k_3fef3aec": "显示水印",
    "k_cc53a57a": "是否小程序",
    "k_c58f67ec": "是否窄屏",
    "k_73226afd": "屏幕尺寸信息",
    "k_4c6cedcc": "获取行为事件",
    "k_f4804b8b": "Renderer 实例",
    "k_25e2291e": "根据 ID 获取指定组件实例（返回值为 Vue 实例）",
    "k_75206eff": "组件 ID",
    "k_c2355592": "获取指定组件所属的页面片实例",
    "k_1d4f7fac": "组件实例",
    "k_a8b6fae2": "等待页面片渲染完成",
    "k_a1296606": "该方法能确保后续逻辑的页面片渲染完成",
    "k_758587d2": "等待所有数据源就绪",
    "k_1013a9c9": "该方法能确保后续逻辑的数据源变量和方法的调用",
    "k_7b38c09a": "发起 HTTP 网络请求",
    "k_105269e2": "返回值为 json.parse 后的对象, 其他与 fetch API 一致",
    "k_f72363bb": "请求资源地址",
    "k_cbea7ea4": "请求参数",
    "k_698205f2": "引入前端公共模块",
    "k_66af362d": "模块路径",
    "k_dac74fd4": "请求数据源接口",
    "k_45f01792": "数据源id",
    "k_a10bbcc": "数据源的接口id",
    "k_c342f7d1": "数据源的请求参数(可选)",
    "k_eacb5a52": "url参数",
    "k_150993ae": "post参数",
    "k_77be7d06": "请求头",
    "k_1ce66f0f": "url路径参数，前端数据源特有",
    "k_18c54511": "当前页面片实例",
    "k_a119f596": "当前页面信息",
    "k_b2d9b5a4": "打开弹窗",
    "k_1b18feb6": "打开当前页面的指定弹窗",
    "k_9d4adcb": "需要打开的弹窗id",
    "k_7fbf2423": "打开弹窗的传参(可选)",
    "k_87bb5e80": "关闭弹窗",
    "k_6b86856d": "关闭当前页面的指定弹窗",
    "k_e40a39c8": "需要关闭的弹窗id（可选, 当参数为空时表示关闭当前调用的弹窗）",
    "k_4a9f930d": "关闭弹窗的返回值(可选)",
    "k_a6701c4b": "前端API",
    "k_67415b6": "全局上下文",
    "k_e69faad7": "接口",
    "k_ae6ce5a2": "集合",
    "k_933f0a92": "一般用于设置 UI 可见性",
    "k_1ffa8b76": "可设置关联页面，页面级别权限，属于「页面权限」",
    "k_322729b3": "可绑定数据源接口, 绑定后用户调用接口须有该权限；也可以不绑定接口，作为应用级别权限使用",
    "k_4fb28b71": "可设置该权限代表的权限集合，方便赋权",
    "k_3791ae81": "查看页面数据",
    "k_a4177c8b": "新建页面数据",
    "k_c29b268d": "更新页面数据",
    "k_72717946": "删除页面数据",
    "k_9ff81031": "上传",
    "k_7aca5db4": "查看",
    "k_3309ee44": "查看页面数据，可以在对应页面调用数据源接口: get/list/count/request/custom_*",
    "k_c5039f5e": "继承自内置权限：查看应用数据",
    "k_57aa613f": "新建",
    "k_8239358a": "新建页面数据，可以在对应页面调用数据源接口: create",
    "k_a425d297": "继承自内置权限：新建应用数据",
    "k_d635ddcf": "更新",
    "k_af997d55": "更新页面数据，可以在对应页面调用数据源接口: update",
    "k_507dc197": "继承自内置权限：更新应用数据",
    "k_62ace18c": "删除",
    "k_8d6926d8": "删除页面数据，可以在对应页面调用数据源接口: delete",
    "k_e929a11f": "继承自内置权限：删除应用数据",
    "k_b4ab8820": "可以在页面使用上传组件",
    "k_d296cf84": "继承自内置权限：上传应用数据",
    "k_4bca5fce": "这个部署版不支持获取部门信息",
    "k_20eab0f4": "获取云函数列表失败",
    "k_f17674e8": "获取数据源接口失败",
    "k_f93a65e": "获取角色用户列表失败",
    "k_bc39f142": "获取角色列表失败",
    "k_91736e1b": "无权查看当前环境权限配置",
    "k_e207c2bf": "对应环境疑似未发版，请先发版再访问",
    "k_48228147": "方法",
    "k_ca5af18d": "全局实例 / 全局 LessCode 实例",
    "k_4e2e12ab": "操作",
    "k_a595254": "请选择...",
    "k_f4821e1e": "此数据源不支持“操作”",
    "k_5e8608ce": "找不到 id={arg_0} 的行为原子",
    "k_3b946cbd": "请勿外传",
    "k_dc969d37": "初始化",
    "k_2cda9ec3": "此时数据源可能还没就绪， **不能调用数据源方法**",
    "k_81ab3892": "渲染完成",
    "k_260b0ada": "此时页面渲染完成",
    "k_f2f7a633": "当前页面 renderer 实例",
    "k_4b0e58ee": "数据源就绪",
    "k_be520a20": "此时可以调用数据源方法了。如果数据源有配置“打开页面时自动拉数据”，那么会等待拉取完成，才执行这里的逻辑",
    "k_503bf855": "销毁",
    "k_73174ea2": "[标题] 请放置组件",
    "k_264a81e2": "[内容] 请放置组件",
    "k_a894f1": "[页脚] 请放置组件",
    "k_6de62429": "属性",
    "k_86587150": "展示类型",
    "k_3b38ba37": "外观",
    "k_19344599": "抽屉",
    "k_55534ba": "移动端适配",
    "k_7bc6ba9c": "抽屉的方向",
    "k_57e47023": "上",
    "k_f7146b42": "右",
    "k_34d6ee68": "下",
    "k_71407e53": "左",
    "k_6b927d0f": "宽度",
    "k_c8f018b2": "高度",
    "k_801a9847": "显示标题",
    "k_6a4f4221": "显示页脚",
    "k_cb14571a": "自定义标题",
    "k_80ff7ac4": "显示右上角的关闭按钮",
    "k_a1567091": "功能",
    "k_23cfb0c": "展示蒙层",
    "k_850dcf5e": "支持点击蒙层关闭",
    "k_9a79a966": "支持键盘 ESC 关闭",
    "k_ba401173": "关闭时保留实例",
    "k_92eb515a": "关闭参数",
    "k_efc8842c": "通过右上角的关闭按钮/点击蒙层/键盘ESC关闭时的默认返回参数",
    "k_d9afd55b": "修改 {arg_0}  id 需要手动更新 LessCode 和关联的组件配置 ",
    "k_6b5c498e": "{arg_0}名称",
    "k_60c13d1": "{arg_0}描述",
    "k_ef2752f1": "请输入描述",
    "k_71396bdf": "{arg_0}{arg_1} 不能为空",
    "k_7f9d6de2": "{arg_0}{arg_1} 已经存在",
    "k_9958d541": "ID由字母、数字、下划线、中划线组成，且只能以字母开头",
    "k_aabed947": "系统组件",
    "k_36c295fe": "打开",
    "k_2aa9a982": "注意：不要在这个时候调用数据源的方法",
    "k_37ecd1c1": "弹窗容器",
    "k_fd5813cc": "重置页脚",
    "k_7769c024": "数据加载中，请稍后...",
    "k_50ad3252": "请选择页面(片)",
    "k_ebf6f6f1": "页面( {arg_0} )不存在或无权访问，请联系应用管理员 ",
    "k_632fca9c": "页面(片)",
    "k_b1b44774": "当前页面内的页面片",
    "k_a792bd21": "流程节点",
    "k_1c84afdb": "流程和节点",
    "k_a2c2ad0": "参数 (页面/页面片内通过 props.xxx 取参)",
    "k_392ee8e0": "加载模式",
    "k_4351ea3": "默认模式显示加载文案和进度条",
    "k_5c568e48": "占位",
    "k_ba47627b": "静默",
    "k_6645596d": "你没有权限访问该项目",
    "k_61b58e50": "获取项目信息失败: {arg_0}",
    "k_f8df9269": "正在初始化AI项目...",
    "k_e3b6ad74": "你没有该项目的编辑权限",
    "k_c213ec27": "初始化AI项目失败: {arg_0}",
    "k_e48ac5b3": "AI项目初始化成功",
    "k_c78ca785": "打开编辑器失败：缺少应用 ID 或页面 ID 参数",
    "k_12477066": "打开编辑器失败：页面不存在",
    "k_e11996e1": "这不是发起流程的页面",
    "k_f032e031": "是否只读",
    "k_870f9752": "可用于区分当前是【发起流程页】还是【流程信息查看页】",
    "k_37063e8": "使用 form 里的数据发起流程",
    "k_db6c4c30": "是否立即跳到流程详情页",
    "k_a94f29e9": "包括 { id, url } 分别是流程单ID、流程单页面地址。",
    "k_36f32f78": "流程单页面地址",
    "k_3a4f696d": "流程发起时间",
    "k_b95f29cd": "请按要求填写完整信息",
    "k_c57b3af3": "审批结果",
    "k_60dfbbf6": "附加数据",
    "k_e012233a": "是否可以审批",
    "k_12abbf4b": "审批状态",
    "k_b6b37fe9": "未进入",
    "k_2b33f3b1": "已同意",
    "k_ac340aed": "已拒绝",
    "k_e6a258": "审批节点的首次进入时间",
    "k_2c39d011": "拒绝",
    "k_10a76eb6": "审批记录",
    "k_e4ccef54": "审批时间",
    "k_af5414b": "审批操作",
    "k_44114cee": "审批操作名（中文）",
    "k_a0bb7c10": "审批附加数据",
    "k_4243429f": "是否可以修改审批人",
    "k_9cf35c5a": "正在修改审批人",
    "k_3b808133": "是否可以撤回",
    "k_7a3ed5e8": "处理审批",
    "k_c9bca75c": "使用当前填的审批意见、附加数据，然后同意或拒绝审批",
    "k_19a8b499": "操作类型（approve或reject）",
    "k_99affa7": "审批表单信息",
    "k_21748b59": "是否刷新页面",
    "k_c00080d7": "修改审批人",
    "k_bf64b307": "撤回审批单",
    "k_c7094d70": "撤回原因",
    "k_8bf01828": "保存修改",
    "k_a19e528c": "请输入审批意见",
    "k_5d6cef6d": "审批发起时间",
    "k_79195c86": "请输入撤回原因",
    "k_1f0337f5": "{{ data.item.operation === \"request-cancel\" ? \"撤回原因\" : \"审批意见\" }}",
    "k_20f9ed2e": "{{data.item.comment || '无'}}",
    "k_c1f8f987": "新审批人",
    "k_c3d4b23f": "data.item.operationName || \"未知操作\"",
    "k_2b61ef35": "通过",
    "k_bc41aa0e": "审批失败：{arg_0}",
    "k_fa1e03eb": "审批表单",
    "k_62e39ed6": "审批信息",
    "k_9dab0db4": "节点标题",
    "k_a2720945": "输出的内容",
    "k_81281655": "是否已执行",
    "k_eeabe100": "是否运行时",
    "k_fe9d08d4": "执行时间",
    "k_36817ece": "无法加载这个节点",
    "k_3a2c8442": "哪个流程",
    "k_eeed722a": "哪个节点",
    "k_94e14a60": "插入",
    "k_9a3e572d": "触发刷新方法",
    "k_a6129a05": "预置事件A",
    "k_aaef185b": "通过 `触发页面片事件` 行为触发该事件执行",
    "k_3e0ae0c8": "触发事件行为的自定义传参",
    "k_e5868a4d": "预置事件B",
    "k_81dc7095": "预置事件C",
    "k_7a3fc12a": "预置事件D",
    "k_8d6b2f84": "预置事件E",
    "k_288dd50f": "内嵌页面(片)",
    "k_e621cb4b": "请放置组件",
    "k_96601653": "组合",
    "k_6cf6f169": "导航栏",
    "k_d9dfdfe7": "菜单栏",
    "k_de3f6751": "腾讯公司 版权所有",
    "k_d8a2afad": "无极",
    "k_bf9fc2a5": "预设页脚",
    "k_2b7a061a": "请选择页面片",
    "k_ac6619e7": "页面片参数 (页面片通过 props.xxx 取参)",
    "k_db697003": "预置事件A触发时执行，可通过 `$event.XXX` 拿到事件参数 XXX",
    "k_aa5b7ad3": "预置事件B触发时执行，可通过 `$event.XXX` 拿到事件参数 XXX",
    "k_f1f83a1c": "预置事件C触发时执行，可通过 `$event.XXX` 拿到事件参数 XXX",
    "k_2ce9658c": "预置事件D触发时执行，可通过 `$event.XXX` 拿到事件参数 XXX",
    "k_7d857536": "预置事件E触发时执行，可通过 `$event.XXX` 拿到事件参数 XXX",
    "k_12934ef": "内嵌页面片",
    "k_f4be42a8": "升级组件",
    "k_5559df05": "主页面",
    "k_d9f05628": "数据",
    "k_81f9b3dd": "布局",
    "k_c128db0a": "[UICore组件]:无效的自定义物料面板配置",
    "k_8f4590e6": "UICore容器",
    "k_f52c3a97": "页面内容",
    "k_f6038854": "设计模式",
    "k_6aba996d": "渲染模式",
    "k_c21674c2": "数据模式",
    "k_28ab348e": "绑定的数据将挂载到内部的state.data",
    "k_7f45c7cf": "传入数据",
    "k_4c62c755": "透传数据源",
    "k_89d9f612": "默认容器类型",
    "k_5680f367": "布局的默认根容器",
    "k_96ea028e": "自定义物料面板",
    "k_fe5d7e71": "[帮助文档]({arg_0})",
    "k_d24e613c": "组件面板",
    "k_d917a44c": "编辑器UI修剪",
    "k_aeeea430": "数据源面板",
    "k_44699d07": "样式面板",
    "k_552adbfc": "行为面板",
    "k_f0677e86": "工具栏",
    "k_cfc697e9": "找不到[{arg_0}]对应的弹窗",
    "k_11b924b2": "方向性图标",
    "k_513aa36a": "编辑类图标",
    "k_750c2d01": "数据类图标",
    "k_1b5eddd1": "网站通用图标",
    "k_ab381309": "提示建议性图标",
    "k_e40ed065": "[wuji-lang]不存在的语言key:{arg_0}, 可选的语言{arg_1}",
    "k_3a29b68c": "无极 AI 模块未加载，请在编辑端开启无极AI插件或者先执行 await w.ai.init() 进行模块初始化",
    "k_38327a82": "filter嵌套格式中，and和or 必须是数组",
    "k_19aebe28": "filter嵌套格式中，对象上的and和or只能有一个",
    "k_76a4befc": "cosId 不存在",
    "k_e1e78fd4": "初始化cos实例失败",
    "k_bbda484b": "这个部署版不支持切换账号，请联系平台运维人员",
    "k_e73d3008": "切换账号的功能仅限产物端（自定义域名）下可用",
    "k_80c752be": "全局弹窗{arg_0}不存在",
    "k_23bee451": "应用 LessCode 执行失败, 请校验应用级 LessCode 代码",
    "k_7139e139": "当前页面片 LessCode",
    "k_e05c0285": "当前页面弹窗",
    "k_154aa5b9": "全局弹窗",
    "k_65c2fdc0": "配置",
    "k_83e17e05": "双向绑定数据",
    "k_decbb89d": "已绑定到 {arg_0} ",
    "k_489945db": "解绑",
    "k_9f832f79": "添加双向绑定",
    "k_603cb18b": "添加参数",
    "k_eb0f4b57": "body请用json格式书写（若用了插值表达式，插值表达式也需要用双引号包住）",
    "k_fd6b6f49": "添加Header",
    "k_67043122": "添加Query",
    "k_6e73fc8f": "无机器人，点击去",
    "k_8eacc445": "获取列表失败",
    "k_583e411e": "没有邮箱配置，点击去",
    "k_9b4915e5": "query (url参数)",
    "k_9427ddac": "body (post包体)",
    "k_e4bdf11d": "请输入JSON格式的对象",
    "k_5b9033fd": "如果想进行动态绑定，请使用 {{}} 符号, eg: {{ state.foobar }}",
    "k_69356f85": "返回值",
    "k_b07e9f5": "输出结构",
    "k_43e92019": "此方法返回值由自定义方法返回👉",
    "k_c616c3ad": "查看自定义代码",
    "k_fd4399af": "方法没有返回值",
    "k_8d797f41": "不传参",
    "k_65872b47": "使用默认参数",
    "k_25102dfb": "表单传参",
    "k_9d00e138": "javascript传参",
    "k_7625a65": "编辑该方法",
    "k_3d701ed4": "数据源方法",
    "k_90ea79d8": "如果想自定义参数，可切换到[表单传参]或[javascript传参]进行配置。",
    "k_fd71b054": "* 查询数据的操作，参数比较固定，推荐使用[表单传参]",
    "k_a4bb75d7": "*\n        create/update等接口的调用、或者参数比较复杂，推荐[javascript传参]",
    "k_c0d077c3": "哪个数据源",
    "k_40e12257": "哪个{arg_0}",
    "k_26612844": "企业微信名",
    "k_43c1ae41": "机器人文档和内部客服文档",
    "k_237bc811": "企业微信个人(固定)",
    "k_b70356ce": "企业微信个人(动态)",
    "k_987248f2": "企业微信客服",
    "k_c1932a78": "列名",
    "k_f7e40879": "取数字段",
    "k_b73f2f71": "支持嵌套取值 eg: a.b ；a[0].b",
    "k_f7a26bdd": "列宽",
    "k_dccc0fc8": "输入展示的字符数目",
    "k_8cc381d1": "拖动可以调整顺序",
    "k_54fd5dc4": "无法通过 [{arg_0}] 找到对应的DataStub",
    "k_61530082": "是否覆盖已有字段结构",
    "k_e8799b7b": "找不到有效的字段",
    "k_a8439897": "选择导出的数据结构",
    "k_29363163": "获取cos列表失败",
    "k_26919dd0": "展开",
    "k_56794467": "COS桶",
    "k_d4841c80": "获取环境失败",
    "k_11f702ca": "获取cos桶失败",
    "k_89f8ab26": "是否同时使用 [{arg_0}] 的数据作为Excel导出的数据",
    "k_1676d8d9": "使用",
    "k_900b3b73": "不使用",
    "k_a9045ace": "点此查看使用方法",
    "k_780873c9": "导出模式",
    "k_c999103a": "单工作表",
    "k_66ac1296": "多工作表",
    "k_6eb123be": "导出的数据",
    "k_ca1c0520": "1、使用页面变量 eg: data.yourSource.listData \n2、使用上一个流程的执行结果 eg: flowState.res.listData",
    "k_dc583a10": "导出字段配置",
    "k_360626d4": "配置模式(固定列)",
    "k_1abb08d4": "代码模式(动态列)",
    "k_8e398123": "使用模板参数",
    "k_638a8aa2": "计算导出的表配置",
    "k_2a4f2a": "表名",
    "k_1faa8471": "支持的格式",
    "k_fbdfa0eb": "关闭时不销毁",
    "k_5f572fdd": "实例id",
    "k_e9412c3b": "该id用于打开多个不销毁的全局弹窗实例时区分实例",
    "k_9a34c9f8": "UI交互",
    "k_de5ea61d": "逻辑",
    "k_d099f7e5": "导入导出",
    "k_3f834a96": "页面导航",
    "k_1fbf2138": "草稿",
    "k_ba87aead": "外部通知",
    "k_d379411b": "流程",
    "k_435ec665": "AI行为",
    "k_afd3dc81": "返回参数 (在打开弹窗行为接收)",
    "k_befd930": "文案",
    "k_bbd635d2": "请设置文案",
    "k_42b5bcb3": "无图标",
    "k_685d6a2f": "宽度(可选)",
    "k_c1edc7b3": "示例： 300px",
    "k_ce9aec82": "文案 (支持HTML)",
    "k_5f65a3f5": "真的要执行操作吗？",
    "k_a6c10c8b": "选择了“否”就终止流程",
    "k_3e4288c8": "确定按钮文字",
    "k_4bbade06": "取消按钮文字",
    "k_cac6d06c": "用户确认结果",
    "k_6ef1fc66": "提示类型",
    "k_f333bb56": "提示持续时间",
    "k_bd1ae025": "是否为同步提示",
    "k_38a16ad0": "请设置内容",
    "k_bea8f01c": "弹出位置",
    "k_aa249141": "左上方",
    "k_e4aaa5f4": "右上方",
    "k_7a343db": "左下方",
    "k_dd02512": "右下方",
    "k_9e4338a9": "请设置通知内容",
    "k_87d39ce8": "提示消息",
    "k_3c44cecd": "请输入一些东西：",
    "k_af6b478e": "默认值",
    "k_edbc9275": "密码模式",
    "k_e701eb7": "输入框模式",
    "k_1a11e9f0": "单行文本",
    "k_6f01c427": "多行文本",
    "k_37e04981": "密码",
    "k_ae19ffdb": "选择了“取消”就终止流程（否则会使用默认值）",
    "k_66fbceac": "用户输入的文本",
    "k_f0f0b2d1": "弹窗关闭后, 才执行后续步骤",
    "k_7635550a": "选择弹窗",
    "k_974ae2ed": "全局弹窗设置",
    "k_31bc6f57": "弹窗参数 (弹窗内通过 props.xxx 取参)",
    "k_72f37eba": "弹窗关闭行为的返回值",
    "k_574502d4": "请键盘按下",
    "k_c7032f1f": "以粘贴内容",
    "k_9a95596f": "取消粘贴",
    "k_ece20544": "触发页面片事件",
    "k_4fd51ad": "外部可通过 `$event.XXX` 拿到这里给出的事件参数 XXX",
    "k_46887ac9": "触发事件名",
    "k_839a3e2f": "选择事件",
    "k_2314c3dd": "触发页面片事件[pagelet:emitEvent]: 必须选择事件",
    "k_58db280b": "三路合并",
    "k_42e604ca": "可以对两个版本内容基于基准版本进行对比合并",
    "k_6b5c77c2": "基准内容",
    "k_887aea61": "远程内容",
    "k_6bb4aebe": "当前内容",
    "k_94679553": "提示合并结果",
    "k_c5e8c73f": "合并的结果",
    "k_6c34fb11": "合并失败{arg_0}",
    "k_b6c7cd42": "复制内容",
    "k_ab2f9455": "是否提示复制成功",
    "k_5d7546c9": "复制成功",
    "k_c4527cc7": "调用 LessCode 方法",
    "k_45a18c6d": "支持 async 的被调方法。会等待完成后，才执行后续步骤。",
    "k_1072df58": "方法名",
    "k_64abe122": "若方法返回false 就终止流程",
    "k_ea8c405b": "如果需要使用变量、表达式，请使用双花括号",
    "k_693e92c8": "被调用函数的返回结果",
    "k_fcb8d24": "未找到 {arg_0} 方法",
    "k_f9ea362d": "将在 Console 输出当前步骤的一些调试信息，需配合浏览器 DevTools 查看",
    "k_c61eae6d": "在线组件发送事件",
    "k_8742c1ac": "将事件从这个在线组件中抛出",
    "k_860cb6b9": "事件Key",
    "k_ae5b82aa": "此处的返回值会作为事件参数传递给使用这个在线组件的页面",
    "k_dc1c76e2": "参数描述",
    "k_6c9fc5ff": "是否提示用户",
    "k_50dc0493": "指定命名空间",
    "k_ee418e6d": "在需要区分业务下使用，不指定时草稿默认在当前页面或者弹窗使用",
    "k_88c23b2": "是否保存当前的草稿？",
    "k_82f82611": "保存",
    "k_afe8015f": "用户取消恢复草稿后是否保留草稿",
    "k_53418628": "是否恢复上次编辑的内容？",
    "k_e6309c92": "恢复",
    "k_80a14618": "如果保存草稿指定了命名空间，需要输入对应的命名空间",
    "k_27471e41": "调用数据源接口",
    "k_5f44e25a": "调用数据源接口并返回接口调用结果，支持批量调用 (注意该步骤不会更新页面数据)",
    "k_ec3d9266": "[调用数据源接口]{arg_0}接口找不到",
    "k_cfb09baa": "[数据源请求] parse db body fail",
    "k_2cc69474": "返回包体",
    "k_91e5dde9": "错误对象(如果有)",
    "k_f3e9a9be": "批量调用数据源接口",
    "k_abae125": "批量调用数据源接口并返回接口调用结果，区别于'调用数据源接口'中的前端批量，这里的批量是单接口后端批量。目前只有DB数据源支持此操作",
    "k_3f9f0029": "哪一个数据源,值格式：data.{sourceId}.$methods,其中 sourceId 要通过 Information 指令获取",
    "k_cd45b1ee": "数据源的方法ID，通过 Information 指令获取。",
    "k_33c44e2a": "数据源 {arg_0} 不存在",
    "k_c25685da": "数据源 {arg_0} 没有名为 {arg_1} 的方法",
    "k_1e5940c0": "该行为会批量并发调用所有数据源的初始化(init)方法",
    "k_2f3b9d5c": "cosID{arg_0}不存在",
    "k_c4d0427b": "获取cos鉴权失败: {arg_0}",
    "k_a118cf2e": "导出失败: {arg_0}",
    "k_2c94375e": "未知错误",
    "k_9f36607a": "支持xlsx、xlsm、csv(单工作表)格式文件的导出",
    "k_e9e9695c": "配置模式",
    "k_e1e11a10": "字段配置",
    "k_b5f10368": "动态字段配置",
    "k_fb41e1e5": "csv格式不支持多sheet导出",
    "k_4aa39d46": "导出成功",
    "k_a969fe1b": "[excel导出] 目标数据不是数组",
    "k_1dfb1e37": "[excel导出] 无效的字段配置",
    "k_efdf84fc": "[excel导出] {arg_0}",
    "k_70ddc8ae": "后续步骤可通过 `flowState.__file__` 获取导入的文件对象",
    "k_6cb362be": "原始数据",
    "k_69bc32": "以 Date 输出日期类型",
    "k_2867ff28": "当前sheet数据",
    "k_f26bf591": "当前行数据",
    "k_c1d887b4": "excel导入的数据",
    "k_e91893f3": "仅支持提取文本类文件数据\n如JSON/CSV/SQL/纯文本文件",
    "k_f314d0fa": "是否支持多选",
    "k_3fd339bd": "是否支持选择文件夹",
    "k_ebf018c5": "不支持该文件类型",
    "k_6672f6bd": "文件提取错误{arg_0}",
    "k_84e12d81": "文件数据",
    "k_df697691": "文件对象",
    "k_782e51cb": "多环境配置(若无需区分环境则不需要配置此项)",
    "k_48792209": "文件",
    "k_bd7bc3be": "上传路径",
    "k_6ae4af4e": "上传头部",
    "k_2f3fb26f": "头部 key 需要是标准写法，比如 Content-Type",
    "k_f3907866": "上传文件路径",
    "k_a92d86c2": "上传至COS失败，无效的文件或COS桶配置",
    "k_78c19cee": "滚动失败, 找不到 {arg_0} 的组件",
    "k_decc77b1": "顶部",
    "k_8c958f15": "底部",
    "k_a66cb0f": "指定位置",
    "k_89a11799": "指定组件",
    "k_a260363d": "纵轴位置 (单位: px)",
    "k_69a21bd8": "组件偏移值 (单位: px)",
    "k_778f580d": "瞬间",
    "k_159b7cfb": "平滑",
    "k_d0db6d9e": "页面 query 参数",
    "k_baf5a140": "页面 params 参数(替换页面路径中的动态参数)",
    "k_dee8fec5": "新窗口打开",
    "k_8152a789": "跳转方式",
    "k_bbdb1e32": "push (history 添加新记录)",
    "k_232e5437": "replace (history 不添加新记录)",
    "k_537ce862": "跳转失败, 无效的页面路径",
    "k_bdbf6cfb": "是否打开：{arg_0}",
    "k_c9de7c76": "无效跳转链接",
    "k_5c296f05": "是否返回上一页",
    "k_8298cc2b": "邮件发送失败",
    "k_991ce1c6": "企业微信通知失败",
    "k_8776aed9": "发送人",
    "k_87c972c2": "收件人",
    "k_6b4bdb44": "抄送",
    "k_b4a66fa3": "密送",
    "k_88ba6118": "邮件主题",
    "k_ce65f7d": "收件人,主题或内容为空,请检查",
    "k_24609626": "消息格式详情请[点击查看](https://developer.work.weixin.qq.com/document/path/95274)",
    "k_74aa8f66": "机器人",
    "k_27231ac8": "消息",
    "k_d668b27": "成功通知",
    "k_992d2e52": "机器人通知配置错误",
    "k_b2c30c5e": "机器人消息应为有效的 JSON",
    "k_130d0afe": "机器人通知成功",
    "k_d6c2487a": "机器人通知失败",
    "k_7c7b63c2": "通知设置",
    "k_c87204a1": "通知应用（消息发送方）",
    "k_cd6d0115": "消息接收人类型",
    "k_7fef35c1": "消息接收人",
    "k_30075892": "消息类型",
    "k_e9edcb6b": "链接",
    "k_4e9ddf9c": "按钮文本",
    "k_25b5db1": "详情",
    "k_1ddf7efa": "企业微信通知-消息接收人不能为空",
    "k_6e6ce56f": "企业微信通知-文本内容不能为空",
    "k_64cd4e72": "企业微信通知-Markdown内容不能为空",
    "k_bcb0cb20": "企业微信通知-文本卡片消息配置有误",
    "k_7e3d2d55": "企业微信通知成功",
    "k_c85e61eb": "唤起配置",
    "k_78c9f6ed": "企业微信名(动态)",
    "k_262dd001": "客服号(uin)",
    "k_c0a669ff": "企业微信名不能为空",
    "k_5637b420": "企业微信客服号不能为空",
    "k_49ef6584": "创建的数据 id 无效",
    "k_f092c6f1": "没有找到对应的电子流配置",
    "k_8ac9756d": "刷新数据",
    "k_7e337e20": "(旧版)从数据源重新拉数据",
    "k_4ee37630": "(旧版)提交修改到数据源",
    "k_cab25464": "行为类型",
    "k_cb7b2f5f": "自动(创建/更新)",
    "k_9307b9ba": "[单条模式] 创建",
    "k_9ecfbaa8": "[单条模式] 更新",
    "k_99303c22": "[单条模式] 删除",
    "k_ac1b0a9d": "[列表模式] 更新列表",
    "k_4cbd990b": "操作完成后，重新载入表单数据",
    "k_9f967bfb": "操作失败：（错误码{arg_0}）{arg_1}",
    "k_35beaf82": "操作失败",
    "k_887aff3f": "数据源操作结果（创建模式下，为型如 { \"id\": xxxx } 的对象）",
    "k_8660c77a": "(上古版)审批驳回",
    "k_7737216e": "(上古版)审批同意",
    "k_5628bc7e": "(上古版)发起流程",
    "k_2c3ea8e7": "新建对象ID",
    "k_7c8c3d01": "审批同意(废弃)",
    "k_46b126e8": "流程实例ID",
    "k_9e304f99": "当前状态",
    "k_9ab62ea7": "流程实例 ID 不能为空",
    "k_c38db77e": "审批失败{arg_0}",
    "k_4a3f0b62": "审批驳回(废弃)",
    "k_f14ee314": "发送HTTP请求",
    "k_94c37ee5": "* 以上所有输入框都支持填写插值表达式",
    "k_70f6fcda": "请求方法",
    "k_df74607c": "请求是否带上Cookie",
    "k_8449f277": "超时时间(毫秒)",
    "k_9f485e2d": "请求失败的提示文案",
    "k_bf5703b2": "请求的响应结果",
    "k_5c48d2f7": "请求失败{arg_0}",
    "k_a845563c": "数据源操作（弃用）",
    "k_58ebfdb1": "重置表单",
    "k_93aee2cc": "提交列表修改",
    "k_8625c190": "(自动)新建或者修改当前数据",
    "k_6cbc4fd6": "新建数据",
    "k_8e27d1ed": "修改当前数据",
    "k_5ae844c5": "删除当前数据",
    "k_801f8b43": "数据源 {arg_0}载入数据失败：{arg_1}",
    "k_ed220acd": "数据源{arg_0}载入数据失败：",
    "k_3d73abd4": "提 交",
    "k_b28b8591": "修改已提交",
    "k_def1fbf": "确定要删除吗？",
    "k_bcc32046": "已删除",
    "k_c82fad7a": "[删除]按钮",
    "k_cf253b2f": "[提交修改]按钮",
    "k_7e50dcc4": "数据源 {arg_0} 配置了 pageCon.filter，同时还有 filterCon。已放弃前者",
    "k_444430e0": "当前不是编辑模式，请检查程序",
    "k_6d1284ad": "[数据源 {arg_0} 初始化出错] {arg_1}",
    "k_3c2fcf6c": "[数据源 {arg_0} 初始化出错]",
    "k_3ba8c339": "发起请求",
    "k_b88cbc7c": "{arg_0} 请求",
    "k_b81f65d4": "完整的表单",
    "k_a825e869": "创建模式下",
    "k_b908ebdc": "编辑模式下",
    "k_b4e0eda3": "创建",
    "k_bd3502a1": "不匹配字段正则表达式：{arg_0}",
    "k_f0c187da": "请通过组件库面板 - 数据源，寻找需要的字段",
    "k_2fdfb965": "管理数据源",
    "k_c7617bee": "添加数据源",
    "k_713188c6": "从数据源导入字段...",
    "k_fd7bb4ad": "当前你的表单里已经有些东西了，切换数据源会丢失原有内容。是否继续？",
    "k_ba7bcc9e": "无法导入此数据源，请通过左侧“数据源”自行拖拽制作表单",
    "k_ffd990d6": "要制作表单，请先添加一个数据源",
    "k_7b73f217": "请选一个数据源，以生成表单？",
    "k_2a94f0a7": "使用空白表单",
    "k_cfa7b86c": "操作失败，无法为 {arg_0} 生成表单，请联系平台方反馈问题",
    "k_60f12616": "表单",
    "k_aaa749fd": "数据字段",
    "k_fca2d25": "根据数据表结构，推荐用这个组件",
    "k_9458a089": "只读字段，请绑定数据",
    "k_186d0aa9": "标题 The Title",
    "k_ded80341": "副标题 如果不需要可以删除",
    "k_2c802746": "这里是一些介绍文字。。请注意修改，或者绑定到数据项的已有字段上",
    "k_ba316f4": "附加文案，不需要可以删除",
    "k_9a72f433": "一个按钮",
    "k_b851c33e": "按钮1",
    "k_439f1dde": "按钮2",
    "k_9c6b12b8": "详情卡片",
    "k_c168c0d4": "图片卡片",
    "k_faa2c640": "列表卡片",
    "k_738e8fff": "数据源日志",
    "k_474fe315": "数据源操作（旧版）",
    "k_60a43bda": "表单型",
    "k_f3ce8893": "带标签的表单",
    "k_2dea198d": "带标签的",
    "k_941fcdcf": "可双向绑定",
    "k_83c6125f": "请在数据源->URL参数中定义$query.{arg_0} 并开启双向绑定 即可修改query",
    "k_1e47e304": "URL参数",
    "k_2b1ce2d3": "数据源依赖",
    "k_99bd28": "模拟路由动态参数",
    "k_81d9c287": "传给弹窗的参数",
    "k_5069894a": "传给页面片的参数",
    "k_5a2afe32": "扩展插件列表",
    "k_7a08a84e": "扩展插件列表浮层",
    "k_44f6a314": "禁用",
    "k_17b4aaa": "启用",
    "k_9b3c9d10": "全应用",
    "k_5e1c73ec": "当前页",
    "k_77b6dbe7": "请问是要全应用启用还是只在当前页启用？",
    "k_db74c191": "暂时还没有扩展插件~",
    "k_58e5482a": "[刷新流程]按钮",
    "k_b1f3c5de": "系统内置",
    "k_4fe45eb8": "当前流程",
    "k_e7c729c4": "流程单标题",
    "k_4fd3370b": "状态",
    "k_d504e954": "发起时参数",
    "k_a3f12f59": "全局变量",
    "k_8d3c0d1f": "各节点数据",
    "k_7a43682c": "流程状态说明",
    "k_14e01ff1": "当前审批人",
    "k_fa394825": "关注人",
    "k_53ed26e4": "流程单网址",
    "k_8e55351a": "流程页面的区块",
    "k_f40ef4e7": "区块标题",
    "k_47fb1a2c": "时间",
    "k_63052eef": "对应步骤节点ID",
    "k_d583610a": "对应步骤节点类型",
    "k_66b0b5ef": "刷新页面数据",
    "k_afb8249": "等待下一区域",
    "k_196b77f3": "区块加载失败：",
    "k_3d32069c": "在这里放置表单",
    "k_15412cc9": "流程节点的页面片",
    "k_445595f6": "要进行页面配置，请在左侧直接操作",
    "k_cabed2d9": "要配置数据源事件，请通过顶部【行为】面板操作",
    "k_ccfb4c84": "这是默认的区块",
    "k_ed512d02": "打散以编辑",
    "k_b08b118a": "注意：打散后，如果你在流程设计时添加了新的参数，这里不会自动同步！",
    "k_5d715b44": "默认页面片内容",
    "k_e1afd816": "这个整体是默认的表单块，根据流程配置自动生成的",
    "k_d3f3f7d8": "如果你需要编辑内部，请点击“打散”按钮",
    "k_8264de": "打散",
    "k_e10f8549": "如果只是想补充一些说明和图例，不建议打散 —— 把要展示的东西，放区块上面/下面/右边就行",
    "k_d655a240": "流程： {arg_0} ",
    "k_20c18a37": "数据授权",
    "k_c2ea3b00": "Mock：流程发起页",
    "k_5ee019cb": "打开流程详情页. {arg_0}",
    "k_8c367c01": "数据： {arg_0} ",
    "k_3fa2551d": "流程发起页",
    "k_3365518c": "流程编辑器已打开。记得两边都要保存",
    "k_f4ca7d2b": "去设计流程",
    "k_f856cae2": "重置区块",
    "k_db73d5f3": "默认导航",
    "k_97f1e51e": "默认菜单",
    "k_7f13915d": "无",
    "k_c2809e98": "获取页面标签列表失败:{arg_0}",
    "k_4603815f": "创建标签失败：{arg_0}",
    "k_8cd92570": "删除标签失败:{arg_0}",
    "k_35683b1": "更新标签失败:{arg_0}",
    "k_c2737357": "回车保存",
    "k_49e82653": "新建标签",
    "k_89ec450": "标签名称不能为空",
    "k_8e07ad0e": "不允许创建重复的标签名",
    "k_b6a559cf": "申请人",
    "k_ded521c7": "申请时间",
    "k_83bea1b3": "应用配置修改未保存, 是否需要保存再跳转?",
    "k_93e0303a": "不保存",
    "k_fddddb41": "流程配置",
    "k_9375da1d": "全部",
    "k_20ccf75a": "审批中",
    "k_d7ed9716": "已通过",
    "k_865536c2": "已驳回",
    "k_d1f52d91": "搜索",
    "k_de4be22a": "基础审批",
    "k_3c3c469": "高级审批",
    "k_45670d5f": "同意所选( {arg_0} ) ",
    "k_533b498b": "驳回所选( {arg_0} ) ",
    "k_c2e098e6": "预览",
    "k_e086749b": "当前节点",
    "k_c11ad7f2": "已撤销(abort)",
    "k_36f12a9e": "已撤销",
    "k_414c29a7": "未知状态",
    "k_69fe099b": "共 {arg_0} 条数据",
    "k_ce5b2b20": "待办审批",
    "k_c30e0582": "我的申请",
    "k_fa7c8c7d": "已办审批",
    "k_6f1bc870": "相关审批",
    "k_25e91e1d": "全部审批",
    "k_438d1654": "权限申请",
    "k_296dc8e6": "发版审批",
    "k_1cff8eba": "获取流程配置列表失败",
    "k_6c9798cd": "获取流程实例失败",
    "k_5e31a56e": "批量审批确认",
    "k_1871f86b": "确认{arg_0}已选中的 {arg_1} 条流程单？",
    "k_e9fe0e6": "确认{arg_0}",
    "k_8c540d4d": "批量审批成功",
    "k_39079cae": "批量审批失败",
    "k_6023fd58": "获取流程配置失败",
    "k_43cfa86b": "内置页面权限",
    "k_992b625e": "自定义页面权限",
    "k_f9ff14e9": "不相关",
    "k_f2eb6e1c": "请输入页面名称或路径进行搜索",
    "k_ff558dc6": "页面标签筛选",
    "k_468c01ad": "概览",
    "k_3c5ef215": "页面视图",
    "k_f11e4084": "权限ID",
    "k_a7974e2f": "权限名",
    "k_80a2a191": "持有权限",
    "k_807a75bc": "请输入权限名进行搜索",
    "k_7935122": "批量授权应用中所有页面，谨慎使用",
    "k_9bc3b3a0": "请输入{arg_0}进行搜索",
    "k_ae20c5cd": "已新增权限: {arg_0}",
    "k_d9923c37": "已删除权限: {arg_0}",
    "k_9309baf1": "已新增角色权限",
    "k_ea46579a": "已删除角色权限",
    "k_e7bff7c3": "更新失败",
    "k_88066a04": "页面权限",
    "k_f191ffb9": "流程权限",
    "k_957c52fe": "自定义接口/集合权限",
    "k_b9dd461": "内置权限",
    "k_18dc91ec": "1天",
    "k_6f43158": "3天",
    "k_fdc2ba01": "1月",
    "k_232af8cb": "3月",
    "k_e399f4b2": "1年",
    "k_9c60fc86": "永久",
    "k_edacc123": "{arg_0}是{arg_1}员工\n      ,有效期最长{arg_2}天",
    "k_8994648d": "有效期",
    "k_b466d9e7": "{arg_0}天",
    "k_3c6c1804": "业务",
    "k_82eeeb95": "云函数接口",
    "k_4a278e31": "申请类型",
    "k_da545de1": "角色",
    "k_6b3f0f4a": "申请页面权限",
    "k_fee333d3": "申请角色",
    "k_c8ecd215": "搜索无结果",
    "k_81d5cd37": "无可申请角色",
    "k_5b20d57": "内置角色不可被申请",
    "k_10dd1820": "基于上下文推荐申请以下角色",
    "k_9c3b7f23": "请联系管理员",
    "k_aad73cc": "其他角色（以下角色没有上下文需要的权限）",
    "k_240d2c9d": "点击查看角色权限：",
    "k_c26416e6": "申请说明",
    "k_41ef5058": "描述正在进行的操作，便于管理员分配恰当的角色",
    "k_273b1943": "额外表单",
    "k_18cd92c9": "查看应用数据",
    "k_68c65e73": "新建应用数据",
    "k_f712dbc7": "更新应用数据",
    "k_533121a4": "删除应用数据",
    "k_ebf73c10": "查看数据",
    "k_4fb1a4ab": "更新数据",
    "k_a636c96f": "删除数据",
    "k_a5264345": "查看权限配置",
    "k_7ee7737e": "更新权限配置",
    "k_bf460c4d": "在流程中上传",
    "k_4f2f0dca": "用户申请的角色不存在",
    "k_2004bff5": "用户申请的角色没有相关的权限",
    "k_56859f51": "获取权限-角色失败",
    "k_37ea722": "申请角色或页面不能为空",
    "k_f98f26df": "申请说明不能为空",
    "k_746f16a6": "校验额外表单失败, {arg_0}",
    "k_3eccf63": "找不到审批人，请联系管理者",
    "k_8ceaed29": "最多只能选择 5 个{arg_0}",
    "k_739c7620": "审批权限申请流程",
    "k_7f5051ae": "你不是审批人之一，无法审批；但管理员可重新指派",
    "k_2018f27f": "请选择或搜索审批人",
    "k_1bf9e1db": "指派审批人",
    "k_73a865ad": "请先选择审批人再指派",
    "k_39198180": "指派成功",
    "k_4c339fae": "指派审批人失败",
    "k_8078ea79": "同意操作，角色不能为空",
    "k_10b49971": "审批失败",
    "k_26e09ec6": "审批单详情",
    "k_199ae69d": "撤销",
    "k_3909871e": "审批重试",
    "k_3f7e4afa": "重新发起审批",
    "k_16f3957b": "通知插件禁止默认的审批操作, 请审批人在「 {arg_0} 」侧审批 ",
    "k_60c78e5a": "单据不存在或无权访问",
    "k_3b336c30": "获取审批单失败",
    "k_4e1905c5": "获取审批单记录失败",
    "k_fb78182c": "确定撤销当前流程单？",
    "k_20b502a3": "说明",
    "k_ff8f5383": "撤单失败, {arg_0}",
    "k_868de658": "确定重试审批执行钩子失败的节点？",
    "k_bfbda1f9": "将会在失败节点上重新执行相同的审批操作，若节点上配置有多个钩子接口，无论之前已经执行成功或失败，都会再次执行",
    "k_8aaa3d2f": "失败节点：{arg_0}({arg_1})",
    "k_cb7d8494": "重试失败, {arg_0}",
    "k_a0dbf204": "重新发起审批失败, {arg_0}",
    "k_fdfa100d": "没有找到审批配置",
    "k_df7c42b": "确定重新发起审批？",
    "k_79b0dd42": "检测到当前审批配置没有关联发起流程页面，无法修改审批数据，将用原审批数据重新发起",
    "k_559254ce": "加载中...",
    "k_150f7b0c": "{{ state.pageTitle || \"流程实例详情\" }}",
    "k_a71d1945": "申请",
    "k_141a5d19": "返回",
    "k_82560793": "权限数据环境隔离，当前环境：{arg_0}",
    "k_430e64f2": "未完成初始化，暂不支持在无极侧管理，请自行到盘古侧管理配置",
    "k_60b884e": "点击前往盘古",
    "k_39f00e20": "自定义权限管理",
    "k_e96f0e2c": "快速选中:",
    "k_cd6f1ec1": "我的部门",
    "k_5f810012": "我的小组",
    "k_3d6371ba": "添加角色({arg_0})失败: {arg_1}",
    "k_f051deb9": "已保存",
    "k_b98b06bf": "添加角色失败",
    "k_68e5ce74": "删除角色失败",
    "k_bba19fb8": "确定删除角色？",
    "k_e29e8fe2": "将删除角色:",
    "k_503cf9cf": "用户已存在",
    "k_db73a310": "用户",
    "k_bd47c55f": "组织",
    "k_48e1a139": "所属业务",
    "k_984837d1": "平台",
    "k_de89129e": "应用类型角色",
    "k_eb32103d": "关联角色",
    "k_3ae666d6": "添加角色",
    "k_7a8ac438": "点击可显示全部（包括已过期的）",
    "k_6640253": "切换所属业务",
    "k_b2e77f1f": "平台(业务无关)",
    "k_5b92d69b": "应用类型角色，业务无关",
    "k_96900603": "第三方鉴权",
    "k_a7949555": "平台配置-运行时自定义鉴权",
    "k_dfc31757": "检测用户权限失败",
    "k_a1b0c310": "盘古",
    "k_e7d36e31": "✅ 持有权限",
    "k_7694c3c6": "🚫 无权限",
    "k_fced3053": "用户有管理员身份",
    "k_a1eee70d": "管理员身份可能来自：应用信息里的管理者、开发环境的开发者，或权限管理里的管理员角色成员、或应用组管理者等",
    "k_42c7e32b": "鉴权来源",
    "k_8310307f": "鉴权结果",
    "k_768dcf56": "检测用户权限",
    "k_70e17c63": "请选择",
    "k_bb1eab31": "相关页面",
    "k_daa6ef15": "相关业务",
    "k_5b70db1e": "选择隔离业务",
    "k_7f714a86": "检测",
    "k_9c08c159": "平台(应用类型角色)",
    "k_1fdff814": "到期时间",
    "k_c4e4938d": "不限期",
    "k_48b09840": "已添加全部角色",
    "k_4b975185": "批量设置到期时间",
    "k_ad9f47e0": "天内到期",
    "k_f1e2574a": "已过期",
    "k_4e3f19b7": "天",
    "k_68232827": "角色类型",
    "k_3864f490": "应用",
    "k_5a56f58": "未启用业务隔离",
    "k_285e70fe": "例如：admin-group",
    "k_476f8c20": "例如：管理组",
    "k_b693096a": "必填",
    "k_d81995f": "最大长度 36",
    "k_da7eafeb": "有效字符：英文字母、数字、下划线以及\"-\"",
    "k_3edf0dc6": "角色重复",
    "k_dbd7eaf1": "所属业务不能为空",
    "k_a843d5b1": "添加用户({arg_0})失败: {arg_1}",
    "k_31265e7c": "添加{arg_0}失败",
    "k_7604490": "删除{arg_0}失败",
    "k_ade53e60": "确定删除{arg_0}？",
    "k_d9f53bd5": "将删除{arg_0}: ",
    "k_849e10c1": "当前关联{arg_0}",
    "k_5034f108": "添加{arg_0}",
    "k_ba6eccf7": "删除{arg_0}",
    "k_7687a68": "开始同步",
    "k_dd3467f4": "同步中",
    "k_4396725f": "同步结束",
    "k_d0d33fae": "无权查看 {arg_0} 环境",
    "k_7348528b": "获取{arg_0}列表失败",
    "k_f78a44fb": "无权更新目标环境",
    "k_9f92c665": "同步失败",
    "k_1fabec56": "获取",
    "k_1e042fbc": "接口绑定权限",
    "k_9f480859": "角色权限",
    "k_78725a7b": "角色用户",
    "k_d9957ca5": "成功",
    "k_3778c38b": "失败，或已存在",
    "k_bef6644d": "成功同步权限配置 {arg_0}",
    "k_1a5d7b61": "同步权限配置 {arg_0} 失败",
    "k_6c9e5e65": "成功同步角色配置 {arg_0}",
    "k_78006865": "同步角色配置 {arg_0} 失败",
    "k_23ab5dc": "将会同步权限、接口类型权限绑定的接口关系、及集合相关权限",
    "k_96319495": "也可以通过「同步角色配置」连带权限进行同步",
    "k_afed0d0d": "将会同步角色、权限、角色-权限绑定及接口类型权限绑定的接口关系",
    "k_9822d682": "不存在的权限会同步新建到目标环境，但相关页面或数据源请自行通过发布版本到目标环境",
    "k_7dab916b": "选择环境",
    "k_b9188b41": "需要同步的权限",
    "k_8ffb580f": "需要同步的角色",
    "k_cd73d5bb": "同步到环境",
    "k_4037a536": "同步角色-用户",
    "k_c8585262": "不会删除目标环境里的现存用户",
    "k_7d004e79": "同步结果",
    "k_32dc1804": "查看结果",
    "k_60223957": "目标环境未启用 POWER 鉴权，无法同步",
    "k_f9c40765": "目标环境未启用只读模式，无法同步",
    "k_6ddc2455": "同步成功",
    "k_7c9ba730": "正在同步中，请稍后",
    "k_b5ed84dc": "同步权限配置",
    "k_c97fedf8": "权限集合",
    "k_4eaf42d1": "- 无效组织，组织ID或已变更",
    "k_1ca4c8ef": "确认删除当前角色？",
    "k_2b34a388": "注意：同时会删除所有关联用户",
    "k_fba524bf": "管理用户/组织",
    "k_1a8277ea": "由系统自动维护",
    "k_462c2438": "角色为业务类型，但应用没有启用业务隔离",
    "k_67c34774": "添加用户",
    "k_b17dacd0": "删除用户",
    "k_1f52ee4": "暂未对接盘古组织",
    "k_fb22627": "添加组织",
    "k_4e976195": "删除组织",
    "k_71c8bf13": "内置角色",
    "k_d63245c7": "关联用户/组织",
    "k_d0aa278a": "未登录的访客",
    "k_c3e73a14": "所有已登录的用户",
    "k_a3e59ae": "所有用户",
    "k_635baa4a": "管理权限",
    "k_3216f2e1": "角色已锁定",
    "k_ee6e145b": "管理角色",
    "k_ac16b642": "修改角色名",
    "k_61fc9306": "带业务隔离的权限",
    "k_53385151": "{arg_0} (点击复制)",
    "k_2ae74dbc": "已复制 {arg_0}",
    "k_9e91bf0d": " 权限",
    "k_f9df2bc3": " 成员",
    "k_a1ff13df": "获取角色和权限信息失败",
    "k_69e7577f": "{arg_0}环境尚未发过版本",
    "k_c99d5202": "生成申请流程成功",
    "k_f5b402c0": "生成申请流程失败",
    "k_2315a75f": "确认生成自定义申请流程？",
    "k_50fe0311": "权限申请流程默认由平台提供",
    "k_ac99a93a": "生成自定义申请流程后，可以",
    "k_8825ec5b": "修改审批人，默认审批人为应用管理员角色",
    "k_4c4392d8": "自行添加申请成功钩子",
    "k_2450190d": "如无以上需求，使用平台提供的申请流程即可",
    "k_38cb73cc": "确认",
    "k_e28192b8": "同步角色配置",
    "k_c9d3e014": "权限申请设置",
    "k_fe7079e": "点击查看",
    "k_1e5e67d": "点击生成",
    "k_ce387cff": "平台级别自定义鉴权启用，在这里配置无效",
    "k_4321c5d6": "第三方鉴权启用，在这里配置无效",
    "k_9a65512f": "无权更新，只读模式",
    "k_fe8fea8e": "无权查看",
    "k_14abaa91": "搜索角色",
    "k_78e4bcd3": "请输入角色ID或角色名关键字",
    "k_c362c204": "编辑角色",
    "k_87aab406": "管理{arg_0}",
    "k_44c27d31": "权限申请设置{arg_0}",
    "k_88774c4d": " - 非开发环境，只读",
    "k_c7e104d6": "以下配置均需要通过发版才能在其他环境生效",
    "k_4a4055f5": "自定义权限申请流程",
    "k_9dfaf2ff": "若无，则使用内置权限申请流程",
    "k_b2198010": "禁止申请页面权限",
    "k_1da74fc4": "申请页面查看权限，平台将会自动生成 /page-path 角色，该角色权限只有该页面的查看权限，无法变更",
    "k_a1294ecc": "申请角色模式",
    "k_38ebb325": "用户申请多个角色时，是合并成一条审批单还是拆分成一个角色一个审批单",
    "k_40ad95b3": "合并",
    "k_76f2a305": "拆分",
    "k_919b1a3d": "用户/组织名",
    "k_e24b7360": "已过期禁用",
    "k_7bf35214": "生效中",
    "k_d21b3b20": "过期时间",
    "k_50e4e26e": "永不过期",
    "k_fdebc213": "设置过期时间成功",
    "k_2e211884": "设置过期时间失败",
    "k_bb6333a6": "设置过期时间",
    "k_ed3d26bd": "已选中",
    "k_dce870ec": "项",
    "k_98b78fee": "用户或组织过滤",
    "k_b22ed9b5": "7 天内过期",
    "k_d52d4681": "30 天内过期",
    "k_31a1504c": "共 {arg_0} 项",
    "k_5683e1fd": "确认移除当前用户/组织？",
    "k_c84d71e6": "注意：同时会删除所有关联角色",
    "k_6b46f5db": "已移除",
    "k_eee9c669": "编辑",
    "k_a76518bc": "移除{arg_0}",
    "k_5fa3adcc": "批量更新过期时间",
    "k_c36a61ff": "请输入名称搜索",
    "k_5d8b172c": "点击右上角按钮或按 Esc 键退出全屏模式",
    "k_10141502": "退出全屏",
    "k_400a25f6": "全屏",
    "k_809c3e0": "扩展字段必须是合法的 JSON 字符串",
    "k_e27dd5a1": "扩展字段必须是一个对象",
    "k_1c9a79e0": "扩展字段不能包含受保护的字段：{arg_0}",
    "k_efc09635": "请到角色里管理该权限，进而让角色成员获得权限",
    "k_f224cdea": "有效字符：英文字母、数字、下划线、\"/\"以及\"-\"",
    "k_b63055fd": "权限重复",
    "k_1860a3a8": "最大长度 128",
    "k_4a513a38": "唯一标识",
    "k_999dc50d": "扩展字段",
    "k_376eade4": "权限类型",
    "k_9afde246": "权限名称",
    "k_79a727c0": "关联页面",
    "k_440ece07": "不填则关联所有页面",
    "k_bc5b184b": "请选择关联页面，不填则可在所有页面上使用",
    "k_31a492b": "检测权限失败",
    "k_b8cdc90c": "角色成员",
    "k_ca7b5b56": "检测权限",
    "k_bbcce4bb": "确认删除当前权限？",
    "k_8c823b1d": "注意：同时会删除绑定，如角色-权限，接口-权限",
    "k_64fa6ed7": "管理关联",
    "k_5cae64a4": "数据源接口",
    "k_d37bb59e": "更多",
    "k_da76877a": "修改权限",
    "k_36c81048": "确认删除该接口关联？",
    "k_ec5542bf": "接口：{arg_0}",
    "k_122826e1": "点击X删除关联接口",
    "k_a04728a1": "关联云函数 (",
    "k_5ef054a": "关联数据源 (",
    "k_a4077aad": "同步权限",
    "k_5eb79084": "请输入权限名搜索",
    "k_69d87f59": "编辑权限",
    "k_dcdd0468": "管理云函数接口",
    "k_5b855952": "管理数据源接口",
    "k_f1d46da8": "已关联",
    "k_880bbc42": "关联云函数",
    "k_e69a7940": "关联数据源接口",
    "k_8adeba38": "绑定成功",
    "k_d9647ebe": "绑定失败",
    "k_5983b0b": "绑定权限",
    "k_4398b947": "选择权限",
    "k_6dc48d87": "解绑成功",
    "k_f75d6f7d": "解绑失败",
    "k_aeff58dc": "解绑权限",
    "k_cb13275": "已绑定权限",
    "k_b5667c73": "选择需要解绑的权限",
    "k_c78e6769": "接口描述",
    "k_e472b730": "无 -",
    "k_f9000da6": " 绑定权限",
    "k_cd5a2be7": " 解绑权限",
    "k_3575eef1": "默认没有权限控制",
    "k_2f0cfe64": "备注",
    "k_e1e0c09f": "获取数据源列表失败",
    "k_3cc13c34": "默认绑定页面的\"{arg_0}\"权限",
    "k_3e78c5f7": "获取绑定列表失败",
    "k_929419a2": "获取权限列表失败",
    "k_bae007b1": "输入数据源ID进行搜索",
    "k_d90eef4f": "输入接口名进行过滤",
    "k_7e77ac95": "无权限",
    "k_2407fac5": "您不是应用组管理员",
    "k_d3b175fb": "请选择{arg_0}页面",
    "k_135d1f30": "{arg_0}页面",
    "k_ced62b37": "默认主键",
    "k_8d1bbf55": "{arg_0} 数据源解析失败, 请检查授权数据库的配置",
    "k_eed42cbc": "添加的页面类型错误!",
    "k_149994f4": "编辑数据表页面",
    "k_becbfec9": "编辑页面信息",
    "k_623abe73": "新建页面",
    "k_8a854c12": "复制页面",
    "k_1b584cc9": "已复制到剪贴板: {arg_0}",
    "k_6b239e55": "参数格式有误，必须是个JSON对象",
    "k_3eeea282": "参数已更新",
    "k_1f540ae3": "添加缺少的默认参数：",
    "k_e6b4477": "删除未定义的参数：",
    "k_4b2db86b": "查找不到ID为[{arg_0}]的流程单",
    "k_2c74e1a6": "若不开启，则节点的调试功能将无效，并且启动后的流程无法作为调试存档点",
    "k_fcbe4cbd": "调试模式",
    "k_ed54e318": "立即启动",
    "k_22799132": "重置",
    "k_ceb8d591": "查看流程单",
    "k_fa950418": "从最近的流程导入",
    "k_41344aba": "设置流程启动参数",
    "k_7bbf33ca": "流程单信息",
    "k_b3ed63cc": "相关审批人",
    "k_6a0d7436": "流程名称",
    "k_73430bde": "项目ID",
    "k_a09831b3": "环境ID",
    "k_9f8df386": "流程状态（中文）",
    "k_491f2fc4": "流程发起页面url",
    "k_11083b9c": "流程版本号",
    "k_296ad854": "流程消息",
    "k_952dbc02": "发起流程的请求信息(headers和cookie)",
    "k_12a4218a": "发起流程时的HTTP请求头",
    "k_4fdb620a": "发起流程时的cookie对象",
    "k_60f2544f": "创建时间",
    "k_344a6a7": "修改时间",
    "k_fe6fe5d": "项目信息",
    "k_ef09cdc7": "项目名称",
    "k_cf04b993": "格式化失败，请检查是否有语法错误",
    "k_1ef05c7": "直接编辑流程配置",
    "k_c339c183": "找不到流程数据",
    "k_81e6a815": "找不到被复制的流程数据",
    "k_6cfc561d": "获取被复制的流程数据失败",
    "k_c0833ab7": "检测到有变动，正在保存",
    "k_7a6e52d0": "流程已启动",
    "k_ccfd3b42": "详询小助手",
    "k_535936bd": "开始",
    "k_fe92a5c5": "结束",
    "k_70a725ee": "系统默认",
    "k_8beb24f1": "新流程要先保存，才能创建页面片",
    "k_1b19594d": "页面片保存失败",
    "k_39a1a1af": "页面片已经创建成功",
    "k_af45e966": "页面片创建完成 ",
    "k_e69af3f9": "是否新打开编辑页",
    "k_fbaf0ba5": "前往编辑",
    "k_98a39580": "保存失败: {arg_0}",
    "k_f54346ca": "页面片已成功安装审批插件",
    "k_8ff4521d": "审批插件安装失败: {arg_0}",
    "k_2cfe9980": "添加页面片",
    "k_fd92c336": "编辑页面片",
    "k_9234cdca": "在{arg_0}中{arg_1}数据",
    "k_2b281888": "按权限",
    "k_42595d24": "按角色",
    "k_6bcd1f51": "用户有以下权限之一",
    "k_f7272687": "用户是以下角色之一",
    "k_20995e58": "鉴权",
    "k_c5cd1cc2": "如发起人 job.creator 或指定某个用户 'user_01', 注意需要引号",
    "k_9d3f1b2f": "鉴权配置",
    "k_3bca261d": "失败",
    "k_ad5b5d5": "将用户从以下角色中 {arg_0} ",
    "k_4ff13a9e": "添加",
    "k_4ff1d92c": "修改配置",
    "k_97b8405b": "通知渠道",
    "k_ed10a38f": "未知的通知插件-",
    "k_d2c7df0c": "推送消息",
    "k_98cd6c4": "输出日志",
    "k_690700f6": "输出",
    "k_d7eed04b": "在详情页显示",
    "k_b19aa852": "详情页展示的表单",
    "k_7ae3fbc5": "使用自定义页面片后，可以设计表单外观、自定义前端逻辑",
    "k_ce7731c0": "启用通知",
    "k_37fa99fd": "通知人",
    "k_68a37c9a": "通知配置",
    "k_692f2e0b": "条件判断",
    "k_981c906": "判断条件",
    "k_53e3e1b5": "判断条件是否成立",
    "k_ffd69665": "是",
    "k_eb061075": "否",
    "k_1fef1bdb": "发起流程的表单",
    "k_537d9a51": "可使用“页面片”定制发起流程的表单外观、自定义前端逻辑",
    "k_d3fd3a45": "发起后，在流程单里隐藏",
    "k_b95bde1f": "下一步",
    "k_6b66312": "DB数据源需要通过「检查响应内容」判断读写操作是否成功",
    "k_92c65e55": "帮我配置",
    "k_3eb464f8": "编辑数据源",
    "k_14f7e0fc": "选择数据源",
    "k_b0f1c405": "请选择接口",
    "k_149f1ae5": "开启后，请求出错将不会阻断整个流程，而是走错误处理分支",
    "k_f9e63f0": "出错时，走自定义兜底逻辑",
    "k_c3981ec7": "如果你的服务响应，是通过返回 body 里的字段，标识是否成功，那请开启此功能并告诉我们如何判断是否成功",
    "k_197f3b0": "需要进一步检查响应内容，判断是否真的成功",
    "k_612566b0": "判断逻辑",
    "k_15fb59a1": "调用数据源",
    "k_1c464359": "执行",
    "k_2cfa60e3": "数据源接口集合",
    "k_cd2419b9": "获取请求参数",
    "k_c67a559f": "启用错误处理分支",
    "k_8f74ba4a": "自定义判断逻辑",
    "k_c08c7c4f": "请求结果",
    "k_9530e976": "包括响应头、响应数据等",
    "k_8678758d": "返回数据",
    "k_f7a3afda": "返回头",
    "k_ae63372d": "\n**http**类型数据源特有。\n\n**注意: 必须到数据源配置中「接口信息」>「透传响应头」配置需要获取的响应头。**\n              ",
    "k_384dac5c": "错误信息(出错时)",
    "k_9a237704": "对应节点配置中「参数」部分的 JavaScript 计算结果",
    "k_877ae787": "剩余{arg_0}次",
    "k_82daae89": "超过了流程级的限制 {arg_0} 次！ ",
    "k_211d1b64": "调整限制",
    "k_aa0b8750": "重试计数器",
    "k_4f4ad7aa": "重试次数",
    "k_63ee8239": "注意：可能需要在「流程详情」里，配置「单节点最多重复运行次数」",
    "k_84af0546": "重试间隔(单位秒)",
    "k_e7ba9576": "自定义失败时行为",
    "k_7467a5be": "如果不勾选，则在超过重试次数后，直接判定整个流程失败",
    "k_b1d1861b": "首次重试的时间",
    "k_f42c6df0": "剩余重试次数",
    "k_ba3f6931": "记录了每次重试的时间",
    "k_c03a57c0": "第几次重试",
    "k_703f22d8": "开始重试时间",
    "k_a6f9c066": "是否确认取消应用关联数据库?",
    "k_12041509": "取消应用关联数据库可能会影响其他页面的数据源, 请谨慎操作",
    "k_33e64d51": "表ID",
    "k_cba617ba": "全量发布",
    "k_56a09f5": "申请发布",
    "k_f9b2777d": "灰度发布",
    "k_a068acf4": "撤下灰度",
    "k_ae78d428": "申请回滚",
    "k_abac75c7": "回滚灰度",
    "k_ace63e62": "调用版本接口",
    "k_910fa44b": "配置信息",
    "k_b101992d": "表版本",
    "k_654d7067": "行版本",
    "k_280703a5": "动作",
    "k_160eef9a": "启用错误处理(error)分支",
    "k_8cfc55ab": "开启后，请求出错将不会阻断整个流程，而是走错误处理分支。",
    "k_169292d5": "结果",
    "k_5666a794": "调用版本接口的响应",
    "k_34da32e8": "发起其他流程",
    "k_80444691": "流程参数(JS表达式)",
    "k_b8c1d45e": "留空则使用当前流程的发起人",
    "k_669ecee3": "等待流程执行结束",
    "k_8a426cce": "如果不勾选，则会在发起后直接继续当前流程。\n\n无论是否等待，你都可以获取到发起的子流程的ID和URL",
    "k_787a98e": "（发起后）流程单ID",
    "k_186c845a": "（发起后）流程单页面url",
    "k_6cc002a8": "（发起后）实际流程参数",
    "k_5686ea01": "Webhook",
    "k_c58fcf59": "Hook标识",
    "k_9c7b0f59": "用于生成 WebHook 的 URL。外部系统通过POST数据到这个地址即可继续流程：\n`{arg_0}`",
    "k_f243599d": "返回出去的数据",
    "k_56789109": "{\n  // 可以按需返回数据给调用方\n}",
    "k_b39805f": "接收到的数据",
    "k_aa161fd3": "字段数据授权",
    "k_ea60e439": "页面仅可访问此处授权的数据。请不要把敏感数据泄漏给访客",
    "k_a164ce2a": "复制 job.{arg_0}",
    "k_298b6bbe": "已复制: {arg_0}",
    "k_396c78ad": "正在更新授权",
    "k_44766633": "请通过【顶部工具栏】授权流程数据",
    "k_7aae26d0": "授权...",
    "k_182c1dbc": "[FlowPagePlugin] 页面片刷新失败",
    "k_4f10a338": "审批用页面能力",
    "k_d302215b": "用于渲染高级流程",
    "k_3bf30d59": "流程节点ID",
    "k_ebbdc26c": "当前流程节点",
    "k_9420c735": "节点ID",
    "k_4383df8a": "无极AI插件",
    "k_ce3c0f9f": "获取插件列表失败:{arg_0}",
    "k_8868e509": "执行扩展插件{arg_0}失败:{arg_1}",
    "k_b731bda1": "获取扩展插件失败",
    "k_12430b10": "暂未获取到可供调试的扩展插件:{arg_0}",
    "k_a5493960": "获取插件列表失败",
    "k_c33ffa3b": "本地debug的插件不支持卸载",
    "k_da65f7c3": "获取应用模版列表失败{arg_0}",
    "k_a48be2c4": "获取自定义应用模版列表失败{arg_0}",
    "k_b26e8e3": "获取应用模版{arg_0}失败:{arg_1}",
    "k_f9d1a346": "获取本地草稿失败: {arg_0}",
    "k_23039328": "获取远程草稿失败: {arg_0}",
    "k_68cee761": "获取修改记录失败{arg_0}",
    "k_d5be9068": "模块名不能为空",
    "k_9a44218f": "模块名由字母、数字、下划线、中划线组成，且只能以字母开头和 .js / .ts 结束",
    "k_9d2db9a7": "该模块名已存在",
    "k_2078e7b7": "输入以 .js 或者 .ts 结尾的模块名称, 按回车确认",
    "k_dc811e1a": "获取id为{arg_0}的修改记录失败: {arg_1}",
    "k_d1eccb74": "获取{arg_0}类型修改记录列表失败: {arg_1}",
    "k_c3f5f2f5": "保存{arg_0}类型修改记录失败: {arg_1}",
    "k_de14bfcb": "默认商店",
    "k_52695b8e": "获取应用组的应用列表失败",
    "k_6eff55b9": "获取组件模版列表失败{arg_0}",
    "k_9fe36397": "获取组件模版失败",
    "k_c529ef0e": "模板更新成功",
    "k_657c06a5": "模板创建成功",
    "k_5ca18ed8": "获取可管理的组件模版列表失败",
    "k_686f6bd": "模板删除成功",
    "k_ffe59be0": "模版删除失败",
    "k_11b9501a": "基础版本",
    "k_59d525e1": "本地版本",
    "k_4bd99660": "选择合入版本",
    "k_7fdaf451": "选择当前版本",
    "k_9b14774e": "没有需要合并的内容",
    "k_41d8db3f": "代码合并失败",
    "k_20a14c1f": "提交描述不允许为空",
    "k_f0e9b9b0": "未选择任何变更",
    "k_fa62b53b": "[{arg_0}] 数据合并失败, 请检查是否还有冲突未解决",
    "k_e89b7cbb": "提交变更",
    "k_7f3f72ef": "版本发布",
    "k_85e3c58": "提交信息（必填）",
    "k_cc4dec15": "提交",
    "k_f7744109": "代码合并",
    "k_d93e2bd2": "代码合并计算中, 请耐心等待",
    "k_78de0700": "分支名称不能为空",
    "k_5a431063": "获取分支列表失败",
    "k_55911220": "获取分支信息失败",
    "k_3b2b0cfd": "自动切换到开发分支",
    "k_4d749f19": "获取用户当前开发分支失败",
    "k_54cd1351": "即将切换至 {arg_0} 分支",
    "k_ac626b79": "切换分支失败",
    "k_a700ac50": "获取未提交变更失败",
    "k_a8e848c3": "获取提交记录失败",
    "k_1c797d5b": "获取分支最新版本失败",
    "k_b4e8c8b3": "没有可{arg_0}的提交",
    "k_15c8585b": "拉取",
    "k_6cc53065": "合并分支{arg_0}到{arg_1}",
    "k_d856cd82": "提交成功",
    "k_a0145225": "提交失败",
    "k_4967384a": "重置提交操作失败",
    "k_43174be1": "拉取应用是否更新数据失败：",
    "k_e0714093": "拉取应用是否更新数据失败：{arg_0}",
    "k_48909764": "更新应用数据失败：",
    "k_2f39dc14": "更新应用数据失败：{arg_0}",
    "k_f3e275b3": "获取项目公告列表失败: {arg_0}",
    "k_33798af5": "已删除公告",
    "k_f9999817": "删除公告失败: {arg_0}",
    "k_89a06b47": "已更新公告",
    "k_fcd0d673": "更新公告失败: {arg_0}",
    "k_c52c1c1f": "已创建公告",
    "k_ead414b4": "创建公告失败: {arg_0}",
    "k_6b50b91d": "获取项目走马灯公告列表失败: {arg_0}",
    "k_2d538e8e": "修改已读状态失败: {arg_0}",
    "k_5cdbb884": "获取数据表列表失败：{arg_0}",
    "k_1ede4f9d": "拉取物料数据失败：{arg_0}",
    "k_db7c9be": "获取公告数据失败",
    "k_f2013b94": "获取公告记录失败",
    "k_34bbca7d": "任务失败，请重新导出",
    "k_80f3136a": "等待任务导出完成...",
    "k_16426b18": "下载链接为空，无法下载",
    "k_ccd14fad": "进行中",
    "k_ee447943": "获取离线列表失败",
    "k_56d4aed": "获取历史版本号失败",
    "k_a02e7f65": "离线任务创建成功",
    "k_3271f4c3": "离线任务创建失败: {arg_0}",
    "k_8385a3b8": "已删除离线记录",
    "k_772c7f8b": "删除离线记录失败: {arg_0}",
    "k_8246609d": "获取离线化配置列表失败",
    "k_9d3170": "离线化配置创建成功",
    "k_2ff0711d": "离线化配置创建失败: {arg_0}",
    "k_8cdae68e": "离线化配置更新成功",
    "k_71d36515": "离线化配置更新失败",
    "k_43b6adee": "离线化配置更新失败: {arg_0}",
    "k_16856889": "已删除离线化配置: {arg_0}",
    "k_98276eb2": "删除离线化配置失败",
    "k_42198a43": "删除离线化配置失败: {arg_0}",
    "k_c9ea45c8": "配置函数调试成功",
    "k_14ae8f47": "配置函数调试失败",
    "k_d386f50e": "配置函数调试失败: {arg_0}",
    "k_c6e60898": "无极默认皮肤",
    "k_837f8fe6": "返回数据为空",
    "k_c12582ce": "获取皮肤失败",
    "k_bf75cf46": "获取皮肤数据失败 {arg_0}",
    "k_35e4efe4": "无法获取皮肤 {arg_0}",
    "k_832a33c5": "获取皮肤demo页面失败",
    "k_4112a0f5": "无权调用",
    "k_52cab8eb": "无权发起流程，点击",
    "k_c7216872": "申请权限",
    "k_487ec374": "公开应用不允许修改数据，只允许读取数据",
    "k_75e7b96e": "请求超时",
    "k_4db76250": "请求失败: code={arg_0}, msg={arg_1}",
    "k_dc58f3b6": "当前登录会话已过期，请重新登录",
    "k_746118cd": "已退出当前登录会话，请重新登录",
    "k_5d795f1f": "因平台安全策略更新，请重新登录",
    "k_d0ced744": "检测到登录态已过期，请重新登录",
    "k_bbac3a15": "登录失败, 请点击重新登录",
    "k_aab0b579": "登录态已过期",
    "k_f0f5041b": "已登录",
    "k_bd106100": "重新登录",
    "k_f2bf1a48": "获取组织架构信息失败，{arg_0}",
    "k_2ad68317": "重新加载整个页面",
    "k_397e6bad": "编辑器已经连接",
    "k_2fe6ef49": "已连接编辑器",
    "k_69fc76d9": "编辑器未连接",
    "k_76555706": "页面配置已更新",
    "k_6f84ebfd": "局部刷新{arg_0}",
    "k_42f5e81": "刷新{arg_0}",
    "k_f5f44245": "稳定版（stable）",
    "k_c059f600": "当前页面地址:{arg_0}",
    "k_530f9d66": "错误时间:{arg_0}",
    "k_e907bac4": "已复制到剪贴板",
    "k_206be49d": "选择编辑器版本",
    "k_6bd0be7e": "请尝试选择新版本，或者复制以下信息联系小助手：",
    "k_ef6f61bc": "点击复制",
    "k_c485050b": "无效",
    "k_310d2b1": "选择后将重新加载编辑器资源，无效版本将被禁用",
    "k_d63dd714": "正在加载应用...",
    "k_4e3cd06d": "测试版本加载失败",
    "k_a5866f2b": "正在准备AI页面开发环境",
    "k_1d3baf61": "模板管理",
    "k_b877305": "公共账号",
    "k_f96d3365": "应用组",
    "k_98babb0e": "组件商店",
    "k_48959f5c": "权限中心",
    "k_fb51ac48": "使用文档",
    "k_8c20c8e3": "数据管理",
    "k_3ecad5e3": "应用管理",
    "k_93102939": "获取应用和页面数据失败: {arg_0}",
    "k_f98a3b9e": "当前页面为低代码开发，不支持此模式",
    "k_26d0e628": "你正在体验非管理员角色",
    "k_b8617726": "非正式环境",
    "k_a47439da": "修改页面",
    "k_7d696af7": "应用权限",
    "k_4f874193": "我的权限",
    "k_a8ca6093": "新用户注册审批",
    "k_4268ef72": "应用组管理",
    "k_f535605c": "恢复管理员角色",
    "k_ba2913ff": "体验非管理员角色",
    "k_f45002d2": "退出模拟登录",
    "k_8ea489b5": "无极 1.0",
    "k_d2824d4c": "当前为debug模式",
    "k_e364cd2e": "路径未定义，无法进行预览",
    "k_e8683a42": "debug模式拉取页面列表失败，请确认是否开启本地开发服务",
    "k_e7c85d6e": "该页面未配置路径，无法跳转",
    "k_42c616d": "模拟",
    "k_db11b1a5": "请在自定义域名产物端预览",
    "k_22b120d0": "未登录",
    "k_1d2f5881": "个人信息",
    "k_135046b9": "密钥",
    "k_83ca1f6d": "获取密钥",
    "k_a28cbb88": "恢复超管或运维身份",
    "k_a0e9c968": "体验非超管或运维身份",
    "k_a12d4022": "获取密钥失败：{arg_0}",
    "k_d617030f": "复制秘钥",
    "k_26da8aec": "获取秘钥",
    "k_8023b7cf": "复制失败！{arg_0}",
    "k_9db94d9": "快速切换",
    "k_70f1cb93": "点击展开更多",
    "k_4d5b2a1a": "预览模式不支持操作",
    "k_30cfdf6e": "环境名称",
    "k_68bca42a": "生产环境",
    "k_4a921bf": "环境选项不能为空",
    "k_ce82051f": "环境配置有重复的选项 '{arg_0}'",
    "k_bb6f8ae6": "获取应用的短路径配置失败",
    "k_2a4064b1": "删除短路径配置失败",
    "k_347eff79": "该导航组[{arg_0}]没有配置页面菜单",
    "k_d5973ce4": "审批页面",
    "k_3c94703e": "你有{arg_0}条待办审批",
    "k_6928183e": "获取审批列表失败",
    "k_1295f1e4": "获取审批流失败",
    "k_64e75f8": "发起的审批有误",
    "k_3fe9f956": "生成中...",
    "k_30128ce0": "服务器开小差，请重新生成二维码",
    "k_34f3e9c4": "继承自组织",
    "k_e62b00e2": "申请续期",
    "k_8e3162d6": "点击角色名称查看详细权限",
    "k_52fbb473": "公告中心",
    "k_9a9f48cf": "展开查看详情",
    "k_768c4341": "无公告",
    "k_1eba2d58": "知道了",
    "k_c8816485": "主菜单切换",
    "k_15bad987": "Powered by 无极",
    "k_336bd15c": "Sidebar.setCurrentGroup: 找不到 {arg_0} 菜单组",
    "k_df44eb0c": "菜单获取路由失败",
    "k_8368999a": "第 {arg_0}  个页面 ",
    "k_a2c7c623": "开发者工具",
    "k_f9a00d11": "关闭其他",
    "k_7df3dcc9": "本地缓存",
    "k_abcaa87f": "你访问的页面貌似不存在？",
    "k_f09521e9": "返回首页",
    "k_a969dc32": "没有权限访问",
    "k_dc80ae0a": "请尝试",
    "k_935f4bcc": "登录",
    "k_b7bbfe82": "后再访问",
    "k_6baf464c": "注意：权限数据环境隔离，当前环境",
    "k_54628b5c": "校验权限失败",
    "k_223445e": "[customRequire] 未实现 {arg_0}",
    "k_f07e8318": "查找不到数据源「{arg_0}」的配置",
    "k_e8a23bc9": "无权调用，点击",
    "k_ff4b4ab7": "数据源中间件不允许重复注册",
    "k_b9262cc2": "项目依赖信息",
    "k_63ac58d4": "修改版本号后保存来实现版本的更新 - 此处的修改是项目级别的",
    "k_94905b98": "请注意：",
    "k_c40b5468": "无法在此处添加/删除依赖，需在源码中添加或删除引用才能生效",
    "k_d97f9efc": "还原",
    "k_ff2e0c04": "更新依赖",
    "k_b6620c6e": "❌ 找不到指定版本的依赖包: {arg_0}",
    "k_eb5afed0": "❌ 找不到指定版本的依赖包",
    "k_7eb7e72e": "❌ 请求的依赖包版本不存在",
    "k_c9968070": "❌ {arg_0} 可能不存在，请检查包名是否错误",
    "k_60012c69": "❌ 找不到指定依赖，请检查包名是否错误",
    "k_cebc7377": "📦 正在安装依赖包...",
    "k_a4b5e666": "❌ 依赖包安装失败",
    "k_9a6cb7bf": "⚡ 正在打包依赖文件...",
    "k_df14598c": "❌ 依赖文件打包失败",
    "k_af282eed": "✅ 依赖更新完成",
    "k_cca46ec5": "❌ 依赖更新失败",
    "k_1662ff42": "正在处理...",
    "k_2f890239": "[xy-client][useDepLoader]依赖加载失败",
    "k_837e1a2b": "依赖更新失败: {arg_0}",
    "k_e394ca14": "检测到依赖更新，正在构建新的依赖文件...",
    "k_c8f16779": "依赖更新失败 - 请检查外部依赖的包名是否错误",
    "k_3e273a3": "拉取全局变量配置失败，请确认本地CLI服务是否启动，或升级CLI工具：{arg_0}",
    "k_96322eac": "无极AI页面暂时不支持作为内嵌页面片使用",
    "k_3681939": "无法加载当前页面，缺少页面id定义",
    "k_22a6adc8": "页面新版本已发布",
    "k_9ec0f0c2": "您可以点击或者刷新页面以体验！🚀🚀🚀",
    "k_4a80970c": "[mock]获取页面数据失败",
    "k_87c18e28": "[mock]数据保存成功",
    "k_b52320f0": "mock数据编辑",
    "k_7f2ecb8c": "Mock标题",
    "k_ee0fa40a": "打开组件编辑器",
    "k_468714ae": "打开本组件的编辑页",
    "k_73ac7b18": "插槽",
    "k_9dcca78d": "事件",
    "k_93c3ab41": "组件联动方法",
    "k_b5adc2c7": "未知的页面{arg_0}",
    "k_f78edf42": "组件内参数 - {arg_0}",
    "k_2f75416b": "请将组件拖到此处",
    "k_13385176": "组件内数据源",
    "k_d9e6b92c": "不再提示",
    "k_dc158dd2": "请在打开的页面中使用组件",
    "k_31e6e541": "，查看调试结果",
    "k_81386661": "在本编辑器中，点击保存按钮（或者按下ctrl/cmd + s），会触发调试页面的更新",
    "k_9d098c4c": "请注意：不要刷新调试页面，不然会导致热更新失效。",
    "k_78c9cbee": "检查权限失败",
    "k_116c2c08": "组件名",
    "k_f472612a": "泄漏次数",
    "k_6c8982be": "执行路径"
};
